export const themes = [
  {
    name: "Korean Netflix Night",
    background: "/Themes/korean-drama-night.jpg",
    video: "/Videos/korean-drama-night.mp4",
    sound: "/Sounds/korean-drama-night.mp3",
    dishes: [
      {
        name: "Buldak Rabokki",
        koreanName: "불닭 라볶이",
        image: "/Dishes/buldak-rabokki.png",
        modalImage: "/modal-images/buldak-rabokki.jpg",
        description: "Spicy fire chicken with rice cakes and melted cheese. Perfect for those who love intense heat and chewy textures.",
        koreanDescription: "매운 불닭과 떡, 라면이 만나 치즈와 함께 어우러진 요리. 매운맛을 좋아하는 사람들에게 완벽한 음식입니다.",
        cookingTime: "25 mins",
        koreanCookingTime: "25분",
        categories: ["Stir Frying", "Main Dish"],
        koreanCategories: ["볶음", "메인 요리"],
        recipeUrl: "https://www.jeenaskitchen.store/",
        timePortion: "25 mins • 2-3 servings",
        koreanTimePortion: "25분 • 2-3인분",
        ingredients: [
          "200g Korean rice cakes (tteok)",
          "150g Korean instant ramen noodles",
          "2 tbsp buldak sauce (Korean fire chicken sauce)",
          "1 tbsp gochujang (Korean red pepper paste)",
          "100g mozzarella cheese, shredded",
          "2 green onions, chopped",
          "1 tbsp vegetable oil",
          "500ml water or chicken broth",
          "1 tsp sugar",
          "1 clove garlic, minced"
        ],
        koreanIngredients: [
          "떡 200g",
          "라면 150g",
          "불닭소스 2큰술",
          "고추장 1큰술",
          "모짜렐라 치즈 100g (갈아서)",
          "대파 2대 (썰어서)",
          "식용유 1큰술",
          "물 또는 닭육수 500ml",
          "설탕 1작은술",
          "마늘 1쪽 (다진 것)"
        ],
        instructions: [
          {
            stepName: "Prepare the base",
            koreanStepName: "기본 준비",
            description: "Bring water to boil in a large pan. Add rice cakes and cook for 3-4 minutes until they start to soften. The rice cakes should be tender but still have a slight chew to them.",
            koreanDescription: "큰 팬에 물을 끓입니다. 떡을 넣고 3-4분간 끓여서 부드러워질 때까지 익힙니다. 떡이 부드럽지만 살짝 쫄깃한 식감이 남아있어야 합니다."
          },
          {
            stepName: "Add noodles and sauce",
            koreanStepName: "면과 소스 추가",
            description: "Add the ramen noodles to the pot with rice cakes. Cook for 2-3 minutes. Mix in buldak sauce, gochujang, minced garlic, and sugar. Stir well to combine all flavors.",
            koreanDescription: "떡이 있는 팬에 라면을 넣고 2-3분간 끓입니다. 불닭소스, 고추장, 다진 마늘, 설탕을 넣고 잘 섞어서 모든 맛이 어우러지도록 합니다."
          },
          {
            stepName: "Reduce and thicken",
            koreanStepName: "졸이기",
            description: "Continue cooking for 3-4 minutes, stirring frequently, until the sauce reduces and becomes thick and glossy. The liquid should coat the noodles and rice cakes nicely.",
            koreanDescription: "3-4분간 자주 저어가며 끓여서 소스가 졸아들고 진하고 윤기있게 만듭니다. 국물이 면과 떡에 잘 코팅되도록 합니다."
          },
          {
            stepName: "Add cheese and finish",
            koreanStepName: "치즈 추가 및 완성",
            description: "Remove from heat and immediately sprinkle shredded mozzarella cheese on top. Cover for 1-2 minutes to let cheese melt. Garnish with chopped green onions before serving.",
            koreanDescription: "불을 끄고 바로 갈아놓은 모짜렐라 치즈를 뿌립니다. 1-2분간 뚜껑을 덮어 치즈가 녹도록 합니다. 대파를 올려서 완성합니다."
          }
        ],
        youtubeUrl: "https://youtu.be/9DZShtHkBIE"
      },
      {
        name: "Corn Dog",
        koreanName: "핫도그",
        image: "/Dishes/corn-dog.png",
        modalImage: "/modal-images/corn-dog.jpg",
        description: "Crispy Korean-style corn dog with cheese and sausage. A popular street food snack that's crispy on the outside.",
        koreanDescription: "치즈와 소시지가 들어간 바삭한 핫도그. 한국의 인기 스트리트 푸드입니다.",
        cookingTime: "15 mins",
        koreanCookingTime: "15분",
        categories: ["Deep Frying", "Snack"],
        koreanCategories: ["튀김", "간식"],
        recipeUrl: "https://www.jeenaskitchen.store/",
        timePortion: "15 mins • 2 servings",
        koreanTimePortion: "15분 • 2인분",
        ingredients: [
          "2 hot dogs or sausages",
          "2 mozzarella cheese sticks",
          "1 cup all-purpose flour",
          "1 cup cornmeal",
          "1 tsp baking powder",
          "1 tsp salt",
          "1 cup milk",
          "1 egg",
          "Wooden skewers",
          "Oil for frying"
        ],
        koreanIngredients: [
          "핫도그 또는 소시지 2개",
          "모짜렐라 치즈스틱 2개",
          "밀가루 1컵",
          "옥수수 가루 1컵",
          "베이킹파우더 1작은술",
          "소금 1작은술",
          "우유 1컵",
          "계란 1개",
          "나무 꼬치",
          "튀김용 기름"
        ],
        instructions: [
          {
            stepName: "Prepare the batter",
            koreanStepName: "반죽 준비",
            description: "Mix flour, cornmeal, baking powder, and salt in a bowl. Add milk and egg, whisk until smooth.",
            koreanDescription: "밀가루, 옥수수가루, 베이킹파우더, 소금을 그릇에 넣고 섞습니다. 우유와 계란을 넣고 부드러워질 때까지 휘젓습니다."
          },
          {
            stepName: "Skewer and coat",
            koreanStepName: "꼬치 꽂고 튀김옷 입히기",
            description: "Skewer hot dogs and cheese sticks. Dip in batter to coat completely.",
            koreanDescription: "핫도그와 치즈스틱에 꼬치를 꽂습니다. 반죽에 완전히 입혀줍니다."
          },
          {
            stepName: "Fry until golden",
            koreanStepName: "바삭하게 튀기기",
            description: "Heat oil to 350°F. Fry corn dogs for 3-4 minutes until golden brown and crispy.",
            koreanDescription: "기름을 175°C로 달군 후 3-4분간 바삭하고 황금색이 될 때까지 튀깁니다."
          }
        ]
      },
      {
        name: "Dalgona",
        koreanName: "달고나",
        image: "/Dishes/dalgona.png",
        modalImage: "/modal-images/dalgona.jpg",
        description: "Traditional Korean honeycomb toffee candy. Made with sugar and baking soda, creating a light and crispy texture.",
        koreanDescription: "설탕과 베이킹소다로 만든 전통 한국 달고나 사탕. 가볍고 바삭한 질감이 특징입니다.",
        cookingTime: "10 mins",
        categories: ["Dessert", "Snack"],
        recipeUrl: "https://www.jeenaskitchen.store/"
      },
      {
        name: "Gimbap",
        koreanName: "김밥",
        image: "/Dishes/gimbap.png",
        modalImage: "/modal-images/gimbap.jpg",
        description: "Korean rice rolls wrapped in seaweed with various fillings. Perfect for picnics and lunch boxes.",
        koreanDescription: "다양한 재료를 넣고 김에 싸서 만든 한국의 대표 도시락 음식. 소풍이나 도시락으로 완벽합니다.",
        cookingTime: "30 mins",
        koreanCookingTime: "30분",
        categories: ["Main Dish", "Side Dish"],
        koreanCategories: ["메인 요리", "반찬"],
        timePortion: "30 mins • 4-6 servings",
        koreanTimePortion: "30분 • 4-6인분",
        ingredients: [
          "4 sheets nori seaweed",
          "2 cups cooked short-grain rice",
          "1 tbsp sesame oil",
          "1 tsp salt",
          "4 strips pickled radish",
          "4 strips cucumber",
          "4 strips carrot",
          "4 strips egg",
          "4 strips ham or spam",
          "1 tbsp sesame seeds"
        ],
        koreanIngredients: [
          "김 4장",
          "밥 2컵",
          "참기름 1큰술",
          "소금 1작은술",
          "단무지 4줄",
          "오이 4줄",
          "당근 4줄",
          "계란 4줄",
          "햄 또는 스팸 4줄",
          "깨 1큰술"
        ],
        instructions: [
          {
            stepName: "Prepare rice",
            koreanStepName: "밥 준비",
            description: "Mix cooked rice with sesame oil and salt. Let cool slightly.",
            koreanDescription: "밥에 참기름과 소금을 넣고 섞어주세요. 살짝 식혀주세요."
          },
          {
            stepName: "Prepare fillings",
            koreanStepName: "재료 준비",
            description: "Cut all vegetables and proteins into thin strips.",
            koreanDescription: "모든 채소와 단백질을 얇게 썰어주세요."
          },
          {
            stepName: "Roll gimbap",
            koreanStepName: "김밥 말기",
            description: "Place rice on Gim(Korean Seaweed), add fillings, and roll tightly. Tightly roll all the fillings and the inner edge of the seaweed (the side closest to your body), then press it down once at the top, using the layer of rice as glue. And roll the pole sliding till the end of the seaweed.",
            koreanDescription: "김에 밥을 펴고 재료를 넣어 꽉 말아주세요. 모든 재료와 김의 안쪽 가장자리를 꽉 말고, 위쪽을 한 번 눌러 밥을 접착제처럼 사용한 후 끝까지 굴려주세요."
          },
          {
            stepName: "Cut and serve",
            koreanStepName: "자르고 내놓기",
            description: "Let the gimbap rest for 5 minutes, then cut into bite-sized pieces with a sharp knife. Serve immediately with pickled radish on the side.",
            koreanDescription: "김밥을 5분간 식힌 후 날카로운 칼로 한 입 크기로 자르세요. 단무지와 함께 바로 내놓으세요."
          }
        ],
        recipeUrl: "https://youtu.be/bJgz1qTa8Cg?si=dvrbMd69eBFAjWbg"
      },
      {
        name: "Korean Fried Chicken",
        koreanName: "치킨",
        image: "/Dishes/korean-fried-chicken.png",
        modalImage: "/modal-images/korean-fried-chicken.jpg",
        description: "Double-fried Korean fried chicken with crispy coating and sweet-spicy sauce. The ultimate comfort food.",
        koreanDescription: "두 번 튀겨서 바삭하게 만든 치킨. 달콤하고 매운 소스와 함께하는 최고의 음식입니다.",
        cookingTime: "45 mins",
        koreanCookingTime: "45분",
        categories: ["Deep Frying", "Main Dish"],
        koreanCategories: ["튀김", "메인 요리"],
        timePortion: "45 mins • 4 servings",
        koreanTimePortion: "45분 • 4인분",
        ingredients: [
          "1 whole chicken, cut into pieces",
          "1 cup all-purpose flour",
          "1/2 cup cornstarch",
          "1 tsp salt",
          "1 tsp black pepper",
          "1 tsp garlic powder",
          "1 tsp ginger powder",
          "Oil for deep frying",
          "1/4 cup gochujang",
          "2 tbsp honey",
          "2 tbsp soy sauce",
          "1 tbsp sesame oil"
        ],
        koreanIngredients: [
          "닭 1마리 (토막내기)",
          "밀가루 1컵",
          "옥수수 전분 1/2컵",
          "소금 1작은술",
          "후추 1작은술",
          "마늘가루 1작은술",
          "생강가루 1작은술",
          "튀김용 기름",
          "고추장 1/4컵",
          "꿀 2큰술",
          "간장 2큰술",
          "참기름 1큰술"
        ],
        instructions: [
          {
            stepName: "Prepare chicken",
            koreanStepName: "닭 준비",
            description: "Cut chicken into pieces and season with salt and pepper.",
            koreanDescription: "닭을 토막내고 소금과 후추로 간을 해주세요."
          },
          {
            stepName: "Make coating",
            koreanStepName: "튀김옷 만들기",
            description: "Mix flour, cornstarch, and spices in a bowl.",
            koreanDescription: "밀가루, 옥수수 전분, 향신료를 그릇에 섞어주세요."
          },
          {
            stepName: "Double fry",
            koreanStepName: "두 번 튀기기",
            description: "Coat chicken and fry twice for extra crispiness.",
            koreanDescription: "닭에 튀김옷을 입히고 바삭하게 두 번 튀겨주세요."
          },
          {
            stepName: "Make sauce",
            koreanStepName: "소스 만들기",
            description: "Mix gochujang, honey, soy sauce, and sesame oil for the sauce.",
            koreanDescription: "고추장, 꿀, 간장, 참기름을 섞어 소스를 만들어주세요."
          }
        ],
        recipeUrl: "https://youtu.be/LwnEkbxD2P8?si=F0yzTnSABITvr9nG"
      }
    ]
  },
  {
    name: "Korean BBQ Restaurant",
    background: "/Themes/korean-bbq-restaurant.jpg",
    video: "/Videos/korean-bbq-restaurant.mp4",
    sound: "/Sounds/korean-bbq-restaurant.mp3",
    dishes: [
      {
        name: "Korean BBQ",
        koreanName: "한국 바베큐",
        image: "/Dishes/korean-bbq.png",
        modalImage: "/modal-images/korean-bbq.jpg",
        description: "Grilled marinated beef and pork with fresh lettuce wraps. The centerpiece of Korean BBQ dining experience.",
        koreanDescription: "양념된 소고기와 돼지고기를 구워 상추에 싸서 먹는 한국의 대표 바베큐 요리입니다.",
        cookingTime: "20 mins",
        categories: ["Main Dish", "Entree"],
        recipeUrl: "https://www.jeenaskitchen.store/"
      },
      {
        name: "Bibimbap",
        koreanName: "비빔밥",
        image: "/Dishes/bibimbap.png",
        modalImage: "/modal-images/bibimbap.jpg",
        description: "Mixed rice bowl with colorful vegetables, egg, and gochujang sauce. A healthy and vibrant Korean classic.",
        koreanDescription: "다양한 나물과 계란, 고추장을 넣고 비벼 먹는 건강한 한국의 대표 요리입니다.",
        cookingTime: "35 mins",
        koreanCookingTime: "35분",
        categories: ["Main Dish", "Vegetable"],
        koreanCategories: ["메인 요리", "채소"],
        recipeUrl: "https://www.jeenaskitchen.store/",
        timePortion: "35 mins • 4 servings",
        koreanTimePortion: "35분 • 4인분",
        ingredients: [
          "4 cups cooked short-grain rice",
          "200g beef bulgogi (marinated thin-sliced beef)",
          "1 cup spinach, blanched",
          "1 cup bean sprouts, blanched",
          "1 cup carrots, julienned",
          "1 cup zucchini, julienned",
          "4 shiitake mushrooms, sliced",
          "4 large eggs",
          "4 tbsp gochujang sauce",
          "2 tbsp sesame oil",
          "2 tbsp vegetable oil",
          "2 cloves garlic, minced",
          "1 tbsp soy sauce",
          "1 tsp sugar",
          "Sesame seeds for garnish"
        ],
        koreanIngredients: [
          "밥 4컵",
          "불고기 200g (양념된 얇게 썬 소고기)",
          "시금치 1컵 (데친 것)",
          "콩나물 1컵 (데친 것)",
          "당근 1컵 (채썰기)",
          "애호박 1컵 (채썰기)",
          "표고버섯 4개 (썰어서)",
          "계란 4개",
          "고추장 4큰술",
          "참기름 2큰술",
          "식용유 2큰술",
          "다진 마늘 2쪽",
          "간장 1큰술",
          "설탕 1작은술",
          "깨 (장식용)"
        ],
        instructions: [
          {
            stepName: "Prepare the rice base",
            koreanStepName: "밥 준비",
            description: "Cook short-grain rice according to package instructions. Keep warm and set aside. The rice should be fluffy and slightly sticky to hold the toppings well.",
            koreanDescription: "포장지 설명에 따라 찰밥을 짓고 따뜻하게 보관해주세요. 밥은 푹신하고 약간 끈적해야 토핑이 잘 붙습니다."
          },
          {
            stepName: "Prepare vegetables",
            koreanStepName: "채소 준비",
            description: "Blanch spinach and bean sprouts separately in boiling water for 1-2 minutes. Drain and season each with a pinch of salt and sesame oil. Sauté carrots, zucchini, and mushrooms separately until tender.",
            koreanDescription: "시금치와 콩나물을 각각 끓는 물에 1-2분간 데쳐주세요. 물기를 빼고 소금과 참기름으로 간을 해주세요. 당근, 애호박, 버섯을 각각 부드러워질 때까지 볶아주세요."
          },
          {
            stepName: "Cook the beef",
            koreanStepName: "불고기 볶기",
            description: "Heat 1 tbsp vegetable oil in a pan over medium-high heat. Cook marinated beef bulgogi for 3-4 minutes until browned and cooked through. Set aside.",
            koreanDescription: "팬에 식용유 1큰술을 넣고 중강불로 달군 후 양념된 불고기를 3-4분간 갈색이 되고 익을 때까지 볶아주세요. 따로 보관해주세요."
          },
          {
            stepName: "Fry the eggs",
            koreanStepName: "계란 후라이",
            description: "In the same pan, fry eggs sunny-side up until whites are set but yolks remain runny. The runny yolk will act as a natural sauce when mixed with the rice.",
            koreanDescription: "같은 팬에서 계란을 노른자가 흐르는 상태로 후라이해주세요. 흐르는 노른자가 밥과 섞일 때 자연스러운 소스 역할을 합니다."
          },
          {
            stepName: "Assemble and serve",
            koreanStepName: "완성하고 내놓기",
            description: "Divide rice among 4 bowls. Arrange vegetables and beef in colorful sections on top of rice. Top each bowl with a fried egg. Serve with gochujang sauce on the side and sprinkle with sesame seeds.",
            koreanDescription: "밥을 4그릇에 나누어 담고, 채소와 불고기를 예쁘게 섹션별로 올려주세요. 각 그릇에 후라이를 올리고 고추장을 곁들여 깨를 뿌려 완성하세요."
          }
        ],
        youtubeUrl: "https://youtu.be/YvcoCSgL5pY?si=RMu3cGEwrP0_oDsw",
      },
      {
        name: "Nangmyeon",
        koreanName: "냉면",
        image: "/Dishes/nang-myeon.png",
        modalImage: "/modal-images/nang-myeon.jpg",
        description: "Cold buckwheat noodles in chilled broth with cucumber and pear. Perfect for hot summer days.",
        koreanDescription: "시원한 육수에 메밀면과 오이, 배를 넣은 냉면. 더운 여름날에 완벽한 음식입니다.",
        cookingTime: "15 mins",
        koreanCookingTime: "15분",
        categories: ["Main Dish", "Beverage"],
        koreanCategories: ["메인 요리", "음료"],
        timePortion: "15 mins • 2 servings",
        koreanTimePortion: "15분 • 2인분",
        ingredients: [
          "200g buckwheat noodles",
          "4 cups cold beef broth",
          "1/2 cucumber, julienned",
          "1/2 Asian pear, julienned",
          "2 hard-boiled eggs, halved",
          "2 tbsp vinegar",
          "1 tbsp sugar",
          "1 tsp salt",
          "Ice cubes",
          "Sesame seeds for garnish"
        ],
        koreanIngredients: [
          "메밀면 200g",
          "차가운 소고기 육수 4컵",
          "오이 1/2개 (채썰기)",
          "배 1/2개 (채썰기)",
          "삶은 계란 2개 (반으로 자르기)",
          "식초 2큰술",
          "설탕 1큰술",
          "소금 1작은술",
          "얼음",
          "깨 (장식용)"
        ],
        instructions: [
          {
            stepName: "Prepare noodles",
            koreanStepName: "면 준비",
            description: "Cook buckwheat noodles according to package instructions. Rinse under cold water and drain.",
            koreanDescription: "메밀면을 포장지 설명에 따라 삶아주세요. 찬물에 헹구고 물기를 빼주세요."
          },
          {
            stepName: "Make cold broth",
            koreanStepName: "시원한 육수 만들기",
            description: "Mix cold beef broth with vinegar, sugar, and salt. Add ice cubes to keep it cold.",
            koreanDescription: "차가운 소고기 육수에 식초, 설탕, 소금을 넣고 섞어주세요. 차갑게 유지하기 위해 얼음을 넣어주세요."
          },
          {
            stepName: "Assemble and serve",
            koreanStepName: "완성하고 내놓기",
            description: "Place noodles in bowls, add cucumber and pear, top with egg halves. Pour cold broth over and garnish with sesame seeds.",
            koreanDescription: "그릇에 면을 넣고 오이와 배를 올린 후 계란 반쪽을 얹어주세요. 차가운 육수를 부어 깨를 뿌려 완성하세요."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      },
      {
        name: "Doenjang Stew",
        koreanName: "된장찌개",
        image: "/Dishes/doenjang-stew.png",
        modalImage: "/modal-images/doenjang-stew.jpg",
        description: "Fermented soybean paste stew with vegetables and tofu. A comforting and nutritious Korean staple.",
        koreanDescription: "채소와 두부가 들어간 된장으로 끓인 찌개. 위로가 되고 영양가 있는 한국의 대표 음식입니다.",
        cookingTime: "25 mins",
        koreanCookingTime: "25분",
        categories: ["Stew & Soup", "Main Dish"],
        koreanCategories: ["찌개 & 국", "메인 요리"],
        timePortion: "25 mins • 4 servings",
        koreanTimePortion: "25분 • 4인분",
        ingredients: [
          "4 cups water",
          "3 tbsp doenjang (fermented soybean paste)",
          "200g tofu, cubed",
          "1 zucchini, sliced",
          "1 onion, sliced",
          "2 green onions, chopped",
          "2 cloves garlic, minced",
          "1 tbsp gochugaru (Korean red pepper flakes)",
          "1 tsp sugar",
          "1 tbsp sesame oil"
        ],
        koreanIngredients: [
          "물 4컵",
          "된장 3큰술",
          "두부 200g (깍둑썰기)",
          "애호박 1개 (썰기)",
          "양파 1개 (썰기)",
          "대파 2대 (썰어서)",
          "다진 마늘 2쪽",
          "고춧가루 1큰술",
          "설탕 1작은술",
          "참기름 1큰술"
        ],
        instructions: [
          {
            stepName: "Prepare vegetables",
            koreanStepName: "채소 준비",
            description: "Cut tofu into cubes and slice zucchini and onion. Chop green onions and mince garlic.",
            koreanDescription: "두부를 깍둑썰기하고 애호박과 양파를 썰어주세요. 대파는 썰고 마늘은 다져주세요."
          },
          {
            stepName: "Make stew",
            koreanStepName: "찌개 끓이기",
            description: "Bring water to boil, add doenjang and stir until dissolved. Add vegetables and tofu, simmer for 15 minutes.",
            koreanDescription: "물을 끓이고 된장을 넣어 녹일 때까지 저어주세요. 채소와 두부를 넣고 15분간 끓여주세요."
          },
          {
            stepName: "Season and serve",
            koreanStepName: "간 맞추고 내놓기",
            description: "Add gochugaru, sugar, and sesame oil. Simmer for 5 more minutes and serve hot.",
            koreanDescription: "고춧가루, 설탕, 참기름을 넣고 5분 더 끓인 후 뜨거운 상태로 내놓으세요."
          }
        ],
        recipeUrl: "https://youtu.be/MqRXbh1W5lg?si=RUBYSU97_si4711o"
      },
      {
        name: "Kimchi Stew",
        koreanName: "김치찌개",
        image: "/Dishes/kimchi-stew.png",
        modalImage: "/modal-images/kimchi-stew.jpg",
        description: "Spicy kimchi stew with pork and vegetables. A warming dish that's perfect for cold weather.",
        koreanDescription: "돼지고기와 채소가 들어간 매운 김치찌개. 추운 날씨에 완벽한 따뜻한 음식입니다.",
        cookingTime: "30 mins",
        koreanCookingTime: "30분",
        categories: ["Stew & Soup", "Main Dish"],
        koreanCategories: ["찌개 & 국", "메인 요리"],
        timePortion: "30 mins • 4 servings",
        koreanTimePortion: "30분 • 4인분",
        ingredients: [
          "2 cups kimchi, chopped",
          "200g pork belly, sliced",
          "1 onion, sliced",
          "2 green onions, chopped",
          "2 cloves garlic, minced",
          "1 tbsp gochujang",
          "1 tbsp gochugaru",
          "1 tbsp soy sauce",
          "1 tsp sugar",
          "4 cups water",
          "1 tbsp sesame oil"
        ],
        koreanIngredients: [
          "김치 2컵 (썰어서)",
          "삼겹살 200g (썰어서)",
          "양파 1개 (썰어서)",
          "대파 2대 (썰어서)",
          "다진 마늘 2쪽",
          "고추장 1큰술",
          "고춧가루 1큰술",
          "간장 1큰술",
          "설탕 1작은술",
          "물 4컵",
          "참기름 1큰술"
        ],
        instructions: [
          {
            stepName: "Prepare ingredients",
            koreanStepName: "재료 준비",
            description: "Chop kimchi and slice pork belly. Slice onion and chop green onions.",
            koreanDescription: "김치를 썰고 삼겹살을 썰어주세요. 양파는 썰고 대파는 썰어주세요."
          },
          {
            stepName: "Cook pork",
            koreanStepName: "돼지고기 볶기",
            description: "Cook pork belly in a pot until browned. Add kimchi and stir-fry for 5 minutes.",
            koreanDescription: "냄비에 삼겹살을 갈색이 될 때까지 볶아주세요. 김치를 넣고 5분간 볶아주세요."
          },
          {
            stepName: "Make stew",
            koreanStepName: "찌개 끓이기",
            description: "Add water, gochujang, gochugaru, soy sauce, and sugar. Simmer for 20 minutes.",
            koreanDescription: "물, 고추장, 고춧가루, 간장, 설탕을 넣고 20분간 끓여주세요."
          },
          {
            stepName: "Finish and serve",
            koreanStepName: "완성하고 내놓기",
            description: "Add green onions and sesame oil. Simmer for 5 more minutes and serve hot.",
            koreanDescription: "대파와 참기름을 넣고 5분 더 끓인 후 뜨거운 상태로 내놓으세요."
          }
        ],
        recipeUrl: "https://youtu.be/JMe9f_1cDXU?si=HD_ferSL_SQoDkT4"
      },
      {
        name: "Gyeran Jjim",
        koreanName: "계란찜",
        image: "/Dishes/gyeran-jjim.png",
        modalImage: "/modal-images/gyeran-jjim.jpg",
        description: "Steamed egg custard with green onions and carrots. A light and fluffy side dish for any meal.",
        koreanDescription: "대파와 당근이 들어간 부드러운 계란찜. 어떤 식사에도 어울리는 가벼운 반찬입니다.",
        cookingTime: "10 mins",
        koreanCookingTime: "10분",
        categories: ["Side Dish", "Entree"],
        koreanCategories: ["반찬", "메인 요리"],
        timePortion: "10 mins • 4 servings",
        koreanTimePortion: "10분 • 4인분",
        ingredients: [
          "6 large eggs",
          "1/2 cup water",
          "1/2 cup milk",
          "2 green onions, chopped",
          "1/2 carrot, diced",
          "1 tsp salt",
          "1/2 tsp sugar",
          "1 tbsp sesame oil",
          "1 tsp sesame seeds"
        ],
        koreanIngredients: [
          "계란 6개",
          "물 1/2컵",
          "우유 1/2컵",
          "대파 2대 (썰어서)",
          "당근 1/2개 (깍둑썰기)",
          "소금 1작은술",
          "설탕 1/2작은술",
          "참기름 1큰술",
          "깨 1작은술"
        ],
        instructions: [
          {
            stepName: "Prepare ingredients",
            koreanStepName: "재료 준비",
            description: "Beat eggs with water and milk. Chop green onions and dice carrots.",
            koreanDescription: "계란을 물과 우유와 함께 풀어주세요. 대파는 썰고 당근은 깍둑썰기해주세요."
          },
          {
            stepName: "Mix and season",
            koreanStepName: "섞고 간 맞추기",
            description: "Add green onions, carrots, salt, and sugar to the egg mixture. Mix well.",
            koreanDescription: "계란물에 대파, 당근, 소금, 설탕을 넣고 잘 섞어주세요."
          },
          {
            stepName: "Steam the eggs",
            koreanStepName: "계란 찌기",
            description: "Pour mixture into a heatproof bowl. Steam for 8-10 minutes until set.",
            koreanDescription: "혼합물을 내열용 그릇에 부어주세요. 8-10분간 찌서 굳혀주세요."
          },
          {
            stepName: "Finish and serve",
            koreanStepName: "완성하고 내놓기",
            description: "Drizzle with sesame oil and sprinkle sesame seeds. Serve hot.",
            koreanDescription: "참기름을 뿌리고 깨를 뿌려주세요. 뜨거운 상태로 내놓으세요."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      }
    ]
  },
  {
    name: "Cafe in Seoul",
    background: "/Themes/korean-cafe.jpg",
    video: "/Videos/korean-cafe.mp4",
    sound: "/Sounds/korean-cafe.mp3",
    dishes: [
      {
        name: "Pat-Bingsu",
        koreanName: "팥빙수",
        image: "/Dishes/pat-bing-su.png",
        modalImage: "/modal-images/pat-bing-su.jpg",
        description: "Shaved ice dessert with sweet red beans, rice cakes, and condensed milk. A refreshing summer treat.",
        koreanDescription: "달콤한 팥과 떡, 연유가 들어간 빙수. 상쾌한 여름 디저트입니다.",
        cookingTime: "20 mins",
        koreanCookingTime: "20분",
        categories: ["Dessert", "Beverage"],
        koreanCategories: ["디저트", "음료"],
        timePortion: "20 mins • 2 servings",
        koreanTimePortion: "20분 • 2인분",
        ingredients: [
          "2 cups shaved ice",
          "1/2 cup sweet red bean paste",
          "1/4 cup rice cakes (tteok)",
          "2 tbsp condensed milk",
          "1 tbsp honey",
          "1/4 cup mixed nuts",
          "1 tbsp sesame seeds"
        ],
        koreanIngredients: [
          "얼음 2컵 (갈아서)",
          "팥앙금 1/2컵",
          "떡 1/4컵",
          "연유 2큰술",
          "꿀 1큰술",
          "견과류 1/4컵",
          "깨 1큰술"
        ],
        instructions: [
          {
            stepName: "Prepare the ice",
            koreanStepName: "얼음 준비",
            description: "Shave ice into fine, fluffy snow-like texture using an ice shaver or food processor.",
            koreanDescription: "얼음갈이기나 푸드프로세서를 사용해 얼음을 부드럽고 푹신한 눈처럼 갈아주세요."
          },
          {
            stepName: "Add toppings",
            koreanStepName: "토핑 올리기",
            description: "Layer sweet red bean paste, rice cakes, and condensed milk over the shaved ice.",
            koreanDescription: "갈아놓은 얼음 위에 팥앙금, 떡, 연유를 층층이 올려주세요."
          },
          {
            stepName: "Garnish and serve",
            koreanStepName: "장식하고 내놓기",
            description: "Drizzle with honey, sprinkle nuts and sesame seeds. Serve immediately while cold.",
            koreanDescription: "꿀을 뿌리고 견과류와 깨를 뿌려주세요. 차가운 상태로 바로 내놓으세요."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      },
      {
        name: "Strawberry Chapsaltteok",
        koreanName: "딸기 찹살떡",
        image: "/Dishes/strawberry-chap-sal-tteok.png",
        modalImage: "/modal-images/strawberry-chap-sal-tteok.jpg",
        description: "Sweet rice cakes filled with fresh strawberries and red bean paste. A delightful Korean dessert.",
        koreanDescription: "신선한 딸기와 팥앙금으로 가득한 달콤한 찹살떡. 맛있는 한국 디저트입니다.",
        cookingTime: "40 mins",
        koreanCookingTime: "40분",
        categories: ["Dessert", "Snack"],
        koreanCategories: ["디저트", "간식"],
        timePortion: "40 mins • 4 servings",
        koreanTimePortion: "40분 • 4인분",
        ingredients: [
          "1 cup glutinous rice flour",
          "1/2 cup water",
          "1/4 cup sugar",
          "1 cup fresh strawberries",
          "1/2 cup red bean paste",
          "1 tbsp honey"
        ],
        koreanIngredients: [
          "찹쌀가루 1컵",
          "물 1/2컵",
          "설탕 1/4컵",
          "신선한 딸기 1컵",
          "팥앙금 1/2컵",
          "꿀 1큰술"
        ],
        instructions: [
          {
            stepName: "Prepare the rice cake",
            koreanStepName: "떡 반죽 만들기",
            description: "Mix glutinous rice flour with water and sugar until smooth.",
            koreanDescription: "찹쌀가루에 물과 설탕을 넣고 부드럽게 섞어주세요."
          },
          {
            stepName: "Add strawberries",
            koreanStepName: "딸기 넣기",
            description: "Gently fold in fresh strawberries and red bean paste.",
            koreanDescription: "신선한 딸기와 팥앙금을 부드럽게 섞어주세요."
          },
        ],
        recipeUrl: "https://youtu.be/WjNX3pNa9Oo?si=uBOihjZsS7jhEHA5"
      },
      {
        name: "Strawberry Sandwich",
        koreanName: "딸기 샌드위치",
        image: "/Dishes/strawberry-sandwich.png",
        modalImage: "/modal-images/strawberry-sandwich.jpg",
        description: "Cream-filled sandwich with fresh strawberries and whipped cream. A popular cafe dessert in Korea.",
        koreanDescription: "신선한 딸기와 휘핑크림으로 가득한 크림 샌드위치. 한국에서 인기 있는 카페 디저트입니다.",
        cookingTime: "15 mins",
        koreanCookingTime: "15분",
        categories: ["Dessert", "Snack"],
        koreanCategories: ["디저트", "간식"],
        timePortion: "15 mins • 2 servings",
        koreanTimePortion: "15분 • 2인분",
        ingredients: [
          "4 slices white bread",
          "1 cup fresh strawberries",
          "1/2 cup heavy cream",
          "2 tbsp sugar",
          "1 tsp vanilla extract"
        ],
        koreanIngredients: [
          "식빵 4장",
          "신선한 딸기 1컵",
          "생크림 1/2컵",
          "설탕 2큰술",
          "바닐라 추출물 1작은술"
        ],
        instructions: [
          {
            stepName: "Prepare the cream",
            koreanStepName: "크림 만들기",
            description: "Whip heavy cream with sugar and vanilla until stiff peaks form.",
            koreanDescription: "생크림에 설탕과 바닐라를 넣고 단단한 거품이 날 때까지 휘핑해주세요."
          },
          {
            stepName: "Assemble sandwich",
            koreanStepName: "샌드위치 만들기",
            description: "Layer cream and strawberries between bread slices.",
            koreanDescription: "식빵 사이에 크림과 딸기를 넣어 샌드위치를 만들어주세요."
          },
          {
            stepName: "Store in refrigerator",
            koreanStepName: "냉장고에서 굳히기",
            description: "Store in refrigerator for at least 30 minutes until set.",
            koreanDescription: "냉장고에서 30분간 식힌 후 반으로 잘라 먹습니다."
          }
        ],
        recipeUrl: "https://youtu.be/WjNX3pNa9Oo?si=uBOihjZsS7jhEHA5"
      },
      {
        name: "Ice Strawberry Latte",
        koreanName: "아이스 딸기 라떼",
        image: "/Dishes/ice-strawberry-latte.png",
        modalImage: "/modal-images/ice-strawberry-latte.jpg",
        description: "Refreshing iced latte with fresh strawberry puree and milk. A beautiful and delicious drink.",
        koreanDescription: "신선한 딸기 퓨레와 우유로 만든 상쾌한 아이스 라떼. 아름답고 맛있는 음료입니다.",
        cookingTime: "5 mins",
        koreanCookingTime: "5분",
        categories: ["Beverage", "Dessert"],
        koreanCategories: ["음료", "디저트"],
        timePortion: "5 mins • 1 serving",
        koreanTimePortion: "5분 • 1인분",
        ingredients: [
          "1/2 cup fresh strawberries",
          "1 cup milk",
          "1 shot espresso",
          "2 tbsp sugar",
          "Ice cubes"
        ],
        koreanIngredients: [
          "신선한 딸기 1/2컵",
          "우유 1컵",
          "에스프레소 1샷",
          "설탕 2큰술",
          "얼음"
        ],
        instructions: [
          {
            stepName: "Make strawberry puree",
            koreanStepName: "딸기 퓨레 만들기",
            description: "Blend fresh strawberries with sugar until smooth.",
            koreanDescription: "신선한 딸기에 설탕을 넣고 부드럽게 갈아주세요."
          },
          {
            stepName: "Assemble latte",
            koreanStepName: "라떼 만들기",
            description: "Layer strawberry puree, ice, milk, and espresso in a glass.",
            koreanDescription: "유리에 딸기 퓨레, 얼음, 우유, 에스프레소를 층층이 쌓아주세요."
          }
        ],
        recipeUrl: "https://youtu.be/WjNX3pNa9Oo?si=uBOihjZsS7jhEHA5"
      },
      {
        name: "Lemon Pound Cake",
        koreanName: "레몬 파운드 케이크",
        image: "/Dishes/lemon-pound-cake.png",
        modalImage: "/modal-images/lemon-pound-cake.jpg",
        description: "Moist lemon pound cake with citrus glaze. A classic cafe dessert with Korean twist.",
        koreanDescription: "시트러스 글레이즈가 있는 촉촉한 레몬 파운드 케이크. 한국식으로 변주한 클래식 카페 디저트입니다.",
        cookingTime: "60 mins",
        koreanCookingTime: "60분",
        categories: ["Dessert", "Snack"],
        koreanCategories: ["디저트", "간식"],
        timePortion: "60 mins • 8 servings",
        koreanTimePortion: "60분 • 8인분",
        ingredients: [
          "2 cups all-purpose flour",
          "1 cup butter, softened",
          "1 cup sugar",
          "4 large eggs",
          "1/4 cup lemon juice",
          "2 tbsp lemon zest",
          "1 tsp vanilla extract",
          "1/2 tsp baking powder",
          "1/4 tsp salt",
          "1/2 cup powdered sugar",
          "2 tbsp lemon juice (for glaze)"
        ],
        koreanIngredients: [
          "중력분 2컵",
          "버터 1컵 (부드럽게)",
          "설탕 1컵",
          "계란 4개",
          "레몬즙 1/4컵",
          "레몬 제스트 2큰술",
          "바닐라 추출물 1작은술",
          "베이킹파우더 1/2작은술",
          "소금 1/4작은술",
          "설탕가루 1/2컵",
          "레몬즙 2큰술 (글레이즈용)"
        ],
        instructions: [
          {
            stepName: "Prepare the batter",
            koreanStepName: "반죽 만들기",
            description: "Cream butter and sugar until fluffy. Add eggs one at a time, then lemon juice, zest, and vanilla.",
            koreanDescription: "버터와 설탕을 푹신해질 때까지 크림화하세요. 계란을 하나씩 넣고 레몬즙, 제스트, 바닐라를 넣어주세요."
          },
          {
            stepName: "Mix dry ingredients",
            koreanStepName: "건조 재료 섞기",
            description: "Sift flour, baking powder, and salt. Gradually fold into wet ingredients until just combined.",
            koreanDescription: "밀가루, 베이킹파우더, 소금을 체에 쳐주세요. 젖은 재료에 서서히 넣고 가볍게 섞어주세요."
          },
          {
            stepName: "Bake the cake",
            koreanStepName: "케이크 굽기",
            description: "Pour batter into greased loaf pan. Bake at 350°F for 50-60 minutes until golden.",
            koreanDescription: "기름칠한 롤팬에 반죽을 부어주세요. 175°C에서 50-60분간 황금색이 될 때까지 구워주세요."
          },
          {
            stepName: "Make glaze and finish",
            koreanStepName: "글레이즈 만들고 완성",
            description: "Mix powdered sugar with lemon juice for glaze. Drizzle over cooled cake and serve.",
            koreanDescription: "설탕가루와 레몬즙을 섞어 글레이즈를 만드세요. 식힌 케이크에 뿌려 완성하세요."
          }
        ],
        recipeUrl: "https://youtu.be/4LEQaOtUt9E?si=4xT8y0XnS9Vq5jJE"
      },
      {
        name: "Tofu Inseolmi",
        koreanName: "두부 인절미",
        image: "/Dishes/tofu-inseolmi.png",
        modalImage: "/modal-images/tofu-inseolmi.jpg",
        description: "Silky tofu pudding with sweet syrup and nuts. A light and healthy Korean dessert.",
        koreanDescription: "달콤한 시럽과 견과류가 들어간 부드러운 두부 푸딩. 가볍고 건강한 한국 디저트입니다.",
        cookingTime: "30 mins",
        koreanCookingTime: "30분",
        categories: ["Dessert", "Snack"],
        koreanCategories: ["디저트", "간식"],
        timePortion: "30 mins • 4 servings",
        koreanTimePortion: "30분 • 4인분",
        ingredients: [
          "1 block soft tofu (300g)",
          "1/4 cup sugar",
          "1 tbsp vanilla extract",
          "1/2 cup water",
          "2 tbsp honey",
          "1/4 cup mixed nuts (almonds, walnuts)",
          "1 tbsp sesame seeds",
          "1 tsp cinnamon powder"
        ],
        koreanIngredients: [
          "부드러운 두부 1모 (300g)",
          "설탕 1/4컵",
          "바닐라 추출물 1큰술",
          "물 1/2컵",
          "꿀 2큰술",
          "견과류 1/4컵 (아몬드, 호두)",
          "깨 1큰술",
          "시나몬 파우더 1작은술"
        ],
        instructions: [
          {
            stepName: "Prepare tofu",
            koreanStepName: "두부 준비",
            description: "Drain tofu and blend with sugar, vanilla, and water until smooth and creamy.",
            koreanDescription: "두부의 물기를 빼고 설탕, 바닐라, 물과 함께 부드럽고 크림처럼 갈아주세요."
          },
          {
            stepName: "Make syrup",
            koreanStepName: "시럽 만들기",
            description: "Heat honey with a little water to make a thin syrup. Let cool slightly.",
            koreanDescription: "꿀에 물을 조금 넣고 가열해 묽은 시럽을 만드세요. 살짝 식혀주세요."
          },
          {
            stepName: "Assemble and serve",
            koreanStepName: "완성하고 내놓기",
            description: "Pour tofu mixture into bowls, drizzle with honey syrup, and top with nuts, sesame seeds, and cinnamon.",
            koreanDescription: "두부 혼합물을 그릇에 부어 꿀 시럽을 뿌리고 견과류, 깨, 시나몬을 올려 완성하세요."
          }
        ],
        recipeUrl: "https://youtu.be/w_QVOV3VJwY?si=y6d9zdY54yMJ3sM3"
      }
    ]
  },
  {
    name: "Korean Dining Room",
    background: "/Themes/korean-dining-room.jpg",
    video: "/Videos/korean-dining-room.mp4",
    sound: "/Sounds/korean-dining-room.mp3",
    dishes: [
      {
        name: "Sundubu Stew",
        koreanName: "순두부찌개",
        image: "/Dishes/sun-du-bu-stew.png",
        modalImage: "/modal-images/sun-du-bu-stew.jpg",
        description: "Spicy soft tofu stew with vegetables and seafood. A comforting dish that's perfect for any meal.",
        koreanDescription: "채소와 해산물이 들어간 매운 순두부찌개. 어떤 식사에도 어울리는 위로가 되는 요리입니다.",
        cookingTime: "20 mins",
        koreanCookingTime: "20분",
        categories: ["Stew & Soup", "Main Dish"],
        koreanCategories: ["찌개 & 국", "메인 요리"],
        timePortion: "20 mins • 2 servings",
        koreanTimePortion: "20분 • 2인분",
        ingredients: [
          "1 package soft tofu (400g)",
          "1/2 cup kimchi, chopped",
          "1/4 cup pork belly, sliced",
          "1/4 cup clams or shrimp",
          "1/2 onion, sliced",
          "2 green onions, chopped",
          "2 cloves garlic, minced",
          "1 tbsp gochugaru",
          "1 tbsp gochujang",
          "1 tbsp soy sauce",
          "1 tsp sugar",
          "2 cups water",
          "1 egg"
        ],
        koreanIngredients: [
          "순두부 1팩 (400g)",
          "김치 1/2컵 (썰어서)",
          "삼겹살 1/4컵 (썰어서)",
          "조개 또는 새우 1/4컵",
          "양파 1/2개 (썰어서)",
          "대파 2대 (썰어서)",
          "다진 마늘 2쪽",
          "고춧가루 1큰술",
          "고추장 1큰술",
          "간장 1큰술",
          "설탕 1작은술",
          "물 2컵",
          "계란 1개"
        ],
        instructions: [
          {
            stepName: "Prepare ingredients",
            koreanStepName: "재료 준비",
            description: "Chop kimchi and slice pork belly. Clean seafood and prepare vegetables.",
            koreanDescription: "김치를 썰고 삼겹살을 썰어주세요. 해산물을 씻고 채소를 준비해주세요."
          },
          {
            stepName: "Make broth",
            koreanStepName: "육수 만들기",
            description: "Sauté pork belly and kimchi in a pot. Add water, gochugaru, gochujang, soy sauce, and sugar.",
            koreanDescription: "냄비에 삼겹살과 김치를 볶아주세요. 물, 고춧가루, 고추장, 간장, 설탕을 넣어주세요."
          },
          {
            stepName: "Add tofu and finish",
            koreanStepName: "두부 넣고 완성",
            description: "Add soft tofu and seafood. Simmer for 10 minutes, then crack an egg on top and serve hot.",
            koreanDescription: "순두부와 해산물을 넣어주세요. 10분간 끓인 후 계란을 깨뜨려 올리고 뜨거운 상태로 내놓으세요."
          }
        ],
        recipeUrl: "https://youtu.be/w_QVOV3VJwY?si=y6d9zdY54yMJ3sM3"
      },
      {
        name: "Grilled Mackerel",
        koreanName: "고등어 구이",
        image: "/Dishes/grilled-mackerel.png",
        modalImage: "/modal-images/grilled-mackerel.jpg",
        description: "Grilled mackerel with simple seasoning. A healthy and flavorful Korean fish dish.",
        koreanDescription: "간단한 양념으로 구운 고등어. 건강하고 맛있는 한국 생선 요리입니다.",
        cookingTime: "15 mins",
        koreanCookingTime: "15분",
        categories: ["Seafood", "Main Dish"],
        koreanCategories: ["해산물", "메인 요리"],
        timePortion: "15 mins • 2 servings",
        koreanTimePortion: "15분 • 2인분",
        ingredients: [
          "2 mackerel fillets",
          "1 tbsp soy sauce",
          "1 tbsp sesame oil",
          "1 tsp sugar",
          "1/2 tsp salt",
          "1/2 tsp black pepper",
          "2 cloves garlic, minced",
          "1 tsp ginger, grated",
          "1 green onion, chopped",
          "1 tbsp sesame seeds"
        ],
        koreanIngredients: [
          "고등어 2토막",
          "간장 1큰술",
          "참기름 1큰술",
          "설탕 1작은술",
          "소금 1/2작은술",
          "후추 1/2작은술",
          "다진 마늘 2쪽",
          "간 생강 1작은술",
          "썬 대파 1대",
          "깨 1큰술"
        ],
        instructions: [
          {
            stepName: "Prepare mackerel",
            koreanStepName: "고등어 준비",
            description: "Clean mackerel and make diagonal cuts on both sides. Pat dry with paper towels.",
            koreanDescription: "고등어를 씻고 양면에 사선으로 칼집을 내주세요. 키친타월로 물기를 제거해주세요."
          },
          {
            stepName: "Make marinade",
            koreanStepName: "양념 만들기",
            description: "Mix soy sauce, sesame oil, sugar, salt, pepper, garlic, and ginger in a bowl.",
            koreanDescription: "간장, 참기름, 설탕, 소금, 후추, 마늘, 생강을 그릇에 넣고 섞어주세요."
          },
          {
            stepName: "Marinate and grill",
            koreanStepName: "양념하고 구우기",
            description: "Marinate mackerel for 10 minutes. Grill on medium-high heat for 6-7 minutes per side until golden.",
            koreanDescription: "고등어를 10분간 양념에 재워주세요. 중강불에서 한 면당 6-7분씩 황금색이 될 때까지 구워주세요."
          },
          {
            stepName: "Garnish and serve",
            koreanStepName: "장식하고 내놓기",
            description: "Sprinkle with green onions and sesame seeds. Serve hot with rice and side dishes.",
            koreanDescription: "대파와 깨를 뿌려주세요. 밥과 반찬과 함께 뜨거운 상태로 내놓으세요."
          }
        ],
        recipeUrl: "https://youtu.be/JMe9f_1cDXU?si=iPTfRIxTuQ_o3Xtp"
      },
      {
        name: "Japchae",
        koreanName: "잡채",
        image: "/Dishes/japchae.png",
        modalImage: "/modal-images/japchae.jpg",
        description: "Stir-fried glass noodles with vegetables and beef. A colorful and delicious Korean noodle dish.",
        koreanDescription: "채소와 소고기가 들어간 볶은 당면. 화려하고 맛있는 한국 면 요리입니다.",
        cookingTime: "30 mins",
        koreanCookingTime: "30분",
        categories: ["Stir Frying", "Main Dish"],
        koreanCategories: ["볶음", "메인 요리"],
        timePortion: "30 mins • 4 servings",
        koreanTimePortion: "30분 • 4인분",
        ingredients: [
          "200g sweet potato starch noodles",
          "100g beef, sliced",
          "1/2 carrot, julienned",
          "1/2 onion, sliced",
          "1/2 bell pepper, julienned",
          "1 cup spinach",
          "4 shiitake mushrooms, sliced",
          "3 tbsp soy sauce",
          "2 tbsp sesame oil",
          "1 tbsp sugar",
          "2 cloves garlic, minced",
          "1 tbsp sesame seeds"
        ],
        koreanIngredients: [
          "당면 200g",
          "소고기 100g (썰어서)",
          "당근 1/2개 (채썰기)",
          "양파 1/2개 (썰어서)",
          "피망 1/2개 (채썰기)",
          "시금치 1컵",
          "표고버섯 4개 (썰어서)",
          "간장 3큰술",
          "참기름 2큰술",
          "설탕 1큰술",
          "다진 마늘 2쪽",
          "깨 1큰술"
        ],
        instructions: [
          {
            stepName: "Prepare noodles",
            koreanStepName: "당면 준비",
            description: "Boil sweet potato noodles for 8-10 minutes until tender. Rinse under cold water and drain.",
            koreanDescription: "당면을 8-10분간 부드러워질 때까지 삶아주세요. 찬물에 헹구고 물기를 빼주세요."
          },
          {
            stepName: "Prepare vegetables",
            koreanStepName: "채소 준비",
            description: "Blanch spinach and sauté each vegetable separately with a little oil until tender.",
            koreanDescription: "시금치를 데치고 각 채소를 기름을 조금 넣고 따로따로 부드러워질 때까지 볶아주세요."
          },
          {
            stepName: "Cook beef",
            koreanStepName: "소고기 볶기",
            description: "Sauté beef with 1 tbsp soy sauce until cooked through. Set aside.",
            koreanDescription: "소고기를 간장 1큰술과 함께 익을 때까지 볶아주세요. 따로 보관해주세요."
          },
          {
            stepName: "Combine and season",
            koreanStepName: "섞고 양념하기",
            description: "Mix noodles with all vegetables and beef. Add remaining soy sauce, sesame oil, sugar, and garlic. Toss well.",
            koreanDescription: "당면에 모든 채소와 소고기를 넣고 섞어주세요. 남은 간장, 참기름, 설탕, 마늘을 넣고 잘 섞어주세요."
          },
          {
            stepName: "Garnish and serve",
            koreanStepName: "장식하고 내놓기",
            description: "Sprinkle with sesame seeds and serve at room temperature or slightly warm.",
            koreanDescription: "깨를 뿌리고 실온 또는 살짝 따뜻한 상태로 내놓으세요."
          }
        ],
        recipeUrl: "https://youtu.be/qZQFmBTllIU?si=EJwWOGAtCaAm2pxq"
      },
      {
        name: "Bossam",
        koreanName: "보쌈",
        image: "/Dishes/bossam.png",
        modalImage: "/modal-images/bossam.jpg",
        description: "Steamed pork wrapped in fresh lettuce with kimchi and ssamjang sauce. A traditional Korean dish.",
        koreanDescription: "신선한 상추에 싸서 먹는 찐 돼지고기와 김치, 쌈장. 전통적인 한국 요리입니다.",
        cookingTime: "60 mins",
        koreanCookingTime: "60분",
        categories: ["Main Dish", "Entree"],
        koreanCategories: ["메인 요리", "메인 요리"],
        timePortion: "60 mins • 4 servings",
        koreanTimePortion: "60분 • 4인분",
        ingredients: [
          "1kg pork belly",
          "1/2 cup soy sauce",
          "1/4 cup rice wine",
          "2 tbsp sugar",
          "1 onion, quartered",
          "4 cloves garlic",
          "1 piece ginger",
          "2 green onions",
          "Fresh lettuce leaves",
          "Kimchi",
          "Ssamjang sauce",
          "Sliced garlic",
          "Green chili peppers"
        ],
        koreanIngredients: [
          "삼겹살 1kg",
          "간장 1/2컵",
          "청주 1/4컵",
          "설탕 2큰술",
          "양파 1개 (4등분)",
          "마늘 4쪽",
          "생강 1조각",
          "대파 2대",
          "신선한 상추 잎",
          "김치",
          "쌈장",
          "마늘 슬라이스",
          "청고추"
        ],
        instructions: [
          {
            stepName: "Prepare pork",
            koreanStepName: "돼지고기 준비",
            description: "Clean pork belly and place in a large pot with soy sauce, rice wine, sugar, onion, garlic, ginger, and green onions.",
            koreanDescription: "삼겹살을 씻고 큰 냄비에 간장, 청주, 설탕, 양파, 마늘, 생강, 대파와 함께 넣어주세요."
          },
          {
            stepName: "Steam pork",
            koreanStepName: "돼지고기 찌기",
            description: "Add water to cover pork and bring to boil. Reduce heat and simmer for 45-50 minutes until tender.",
            koreanDescription: "돼지고기가 잠길 정도로 물을 넣고 끓여주세요. 불을 줄이고 45-50분간 부드러워질 때까지 끓여주세요."
          },
          {
            stepName: "Prepare accompaniments",
            koreanStepName: "곁들일 것 준비",
            description: "Wash and prepare fresh lettuce leaves. Slice garlic and green chili peppers. Prepare kimchi and ssamjang.",
            koreanDescription: "신선한 상추 잎을 씻고 준비해주세요. 마늘과 청고추를 썰어주세요. 김치와 쌈장을 준비해주세요."
          },
          {
            stepName: "Slice and serve",
            koreanStepName: "썰고 내놓기",
            description: "Slice steamed pork into thin pieces. Serve with lettuce, kimchi, ssamjang, garlic, and chili peppers for wrapping.",
            koreanDescription: "찐 돼지고기를 얇게 썰어주세요. 상추, 김치, 쌈장, 마늘, 고추와 함께 싸먹을 수 있도록 내놓으세요."
          }
        ],
        recipeUrl: "https://youtube.com/@jeena.s.kitchen?si=kijH9ON2HChzqvUE"
      },
      {
        name: "Kimchi",
        koreanName: "김치",
        image: "/Dishes/kimchi.png",
        modalImage: "/modal-images/kimchi.jpg",
        description: "Fermented napa cabbage with spicy seasoning. The essential Korean side dish and condiment.",
        koreanDescription: "매운 양념으로 발효시킨 배추김치. 한국의 필수 반찬이자 양념입니다.",
        cookingTime: "2-3hours",
        koreanCookingTime: "2-3시간",
        categories: ["Kimchi & Pickle", "Side Dish"],
        koreanCategories: ["김치 & 절임", "반찬"],
        timePortion: "2-3 hours • 1 large jar",
        koreanTimePortion: "2-3시간 • 큰 항아리 1개",
        ingredients: [
          "1 large napa cabbage",
          "1/2 cup coarse sea salt",
          "1/4 cup gochugaru (Korean red pepper flakes)",
          "3 tbsp fish sauce",
          "2 tbsp salted shrimp",
          "1 tbsp sugar",
          "1/4 cup minced garlic",
          "1 tbsp minced ginger",
          "1/2 cup chopped green onions",
          "1/4 cup chopped radish"
        ],
        koreanIngredients: [
          "배추 1포기",
          "굵은 소금 1/2컵",
          "고춧가루 1/4컵",
          "젓갈 3큰술",
          "새우젓 2큰술",
          "설탕 1큰술",
          "다진 마늘 1/4컵",
          "다진 생강 1큰술",
          "썬 대파 1/2컵",
          "썬 무 1/4컵"
        ],
        instructions: [
          {
            stepName: "Prepare cabbage",
            koreanStepName: "배추 준비",
            description: "Cut cabbage in half and salt generously. Let sit for 2 hours, turning every 30 minutes.",
            koreanDescription: "배추를 반으로 자르고 소금을 듬뿍 뿌려주세요. 30분마다 뒤집어가며 2시간 재워주세요."
          },
          {
            stepName: "Make seasoning paste",
            koreanStepName: "양념 만들기",
            description: "Mix gochugaru, fish sauce, salted shrimp, sugar, garlic, and ginger.",
            koreanDescription: "고춧가루, 젓갈, 새우젓, 설탕, 마늘, 생강을 섞어주세요."
          },
          {
            stepName: "Stuff and ferment",
            koreanStepName: "양념 넣고 발효",
            description: "Rinse cabbage, stuff with seasoning paste, and ferment for 2-3 days in the room temperature, checking every 12 hours. Once bubbles appear, transfer to the fridge.",
            koreanDescription: "배추를 헹구고 양념을 넣어 상온에서 2-3일간 발효시켜주세요. 12시간 마다 확인하고 버블이 생기면 냉장고에 보관해주세요."
          },
          {
            stepName: "Serve and store",
            koreanStepName: "내놓고 보관하기",
            description: "Serve kimchi with rice and other Korean dishes. Store in the fridge for up to 1 month.",
            koreanDescription: "김치를 밥과 함께 내놓고 1개월 동안 냉장고에 보관해주세요."
          }
        ],
        recipeUrl: "https://youtu.be/naS9csQ4inA?si=sdRdv7zv__VmXJiS"
      }
    ]
  },
  {
    name: "Grandmother's House",
    background: "/Themes/korean-grandmother-house.jpg",
    video: "/Videos/grandmother-house.mp4",
    sound: "/Sounds/korean-grandmother-house.mp3",
    dishes: [
      {
        name: "Samgyetang",
        koreanName: "삼계탕",
        image: "/Dishes/sam-gye-tang.png",
        modalImage: "/modal-images/sam-gye-tang.jpg",
        description: "Simple Chicken soup with glutinous rice and herbs. A nourishing Korean chicken soup.",
        koreanDescription: "인삼과 찹쌀, 약재가 들어간 닭고기 국. 영양가 풍부한 한국의 대표 보양식입니다.",
        cookingTime: "60 mins",
        koreanCookingTime: "60분",
        categories: ["Stew & Soup", "Main Dish"],
        koreanCategories: ["찌개 & 국", "메인 요리"],
        timePortion: "60 mins • 2 servings",
        koreanTimePortion: "60분 • 2인분",
        ingredients: [
          "1 whole chicken (1.5kg)",
          "1/2 cup glutinous rice",
          "1 fresh ginseng root",
          "4 jujubes (dried red dates)",
          "2 chestnuts",
          "4 garlic cloves",
          "2 green onions",
          "1 tbsp salt",
          "1 tsp black pepper",
          "8 cups water"
        ],
        koreanIngredients: [
          "닭 1마리 (1.5kg)",
          "찹쌀 1/2컵",
          "인삼 1뿌리",
          "대추 4개",
          "밤 2개",
          "마늘 4쪽",
          "대파 2대",
          "소금 1큰술",
          "후추 1작은술",
          "물 8컵"
        ],
        instructions: [
          {
            stepName: "Prepare chicken",
            koreanStepName: "닭 준비",
            description: "Clean the chicken thoroughly and stuff with glutinous rice, ginseng, jujubes, and chestnuts.",
            koreanDescription: "닭을 깨끗이 씻고 찹쌀, 인삼, 대추, 밤을 넣어 채워주세요."
          },
          {
            stepName: "Cook the soup",
            koreanStepName: "국 끓이기",
            description: "Place chicken in a pot with water, garlic, and green onions. Bring to boil, then simmer for 45 minutes.",
            koreanDescription: "냄비에 닭, 물, 마늘, 대파를 넣고 끓인 후 45분간 끓여주세요."
          },
          {
            stepName: "Season and serve",
            koreanStepName: "간 맞추고 내놓기",
            description: "Season with salt and pepper. Serve hot with the stuffed ingredients.",
            koreanDescription: "소금과 후추로 간을 맞추고 뜨거운 상태로 내놓으세요."
          }
        ],
        recipeUrl: "https://youtu.be/AxWvZRwbQrM"
      },
      {
        name: "Kongguksu",
        koreanName: "콩국수",
        image: "/Dishes/kong-guk-su.png",
        modalImage: "/modal-images/kong-guk-su.jpg",
        description: "Cold soybean milk noodles with cucumber and sesame. A refreshing summer noodle dish.",
        koreanDescription: "오이와 깨가 들어간 차가운 콩국수. 상쾌한 여름 면 요리입니다.",
        cookingTime: "45 mins",
        koreanCookingTime: "45분",
        categories: ["Main Dish", "Beverage"],
        koreanCategories: ["메인 요리", "음료"],
        timePortion: "45 mins • 4 servings",
        koreanTimePortion: "45분 • 4인분",
        ingredients: [
          "400g wheat noodles",
          "2 cups soybeans",
          "1 cucumber, julienned",
          "1/2 cup sesame seeds",
          "2 tbsp salt",
          "1 tbsp sugar",
          "4 cups water",
          "Ice cubes"
        ],
        koreanIngredients: [
          "밀면 400g",
          "콩 2컵",
          "오이 1개 (채썰기)",
          "깨 1/2컵",
          "소금 2큰술",
          "설탕 1큰술",
          "물 4컵",
          "얼음"
        ],
        instructions: [
          {
            stepName: "Make soybean milk",
            koreanStepName: "콩국 만들기",
            description: "Soak soybeans overnight, then blend with water. Strain through cheesecloth to get smooth milk.",
            koreanDescription: "콩을 하룻밤 불린 후 물과 함께 갈아주세요. 거즈로 걸러 부드러운 콩국을 만드세요."
          },
          {
            stepName: "Cook noodles",
            koreanStepName: "면 삶기",
            description: "Boil wheat noodles according to package instructions. Rinse under cold water and drain.",
            koreanDescription: "밀면을 포장지 설명에 따라 삶아주세요. 찬물에 헹구고 물기를 빼주세요."
          },
          {
            stepName: "Assemble and serve",
            koreanStepName: "완성하고 내놓기",
            description: "Place noodles in bowls, add cold soybean milk, cucumber, and sesame seeds. Serve with ice.",
            koreanDescription: "그릇에 면을 넣고 차가운 콩국, 오이, 깨를 올려주세요. 얼음과 함께 내놓으세요."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      },
      {
        name: "Hwachae",
        koreanName: "화채",
        image: "/Dishes/hwa-chae.png",
        modalImage: "/modal-images/hwa-chae.jpg",
        description: "Traditional Korean fruit punch with seasonal fruits and honey. A refreshing summer drink.",
        koreanDescription: "계절 과일과 꿀이 들어간 전통 한국 과일 펀치. 상쾌한 여름 음료입니다.",
        cookingTime: "15 mins",
        koreanCookingTime: "15분",
        categories: ["Beverage", "Dessert"],
        koreanCategories: ["음료", "디저트"],
        timePortion: "15 mins • 4 servings",
        koreanTimePortion: "15분 • 4인분",
        ingredients: [
          "1 cup watermelon, cubed",
          "1 cup cantaloupe, cubed",
          "1 cup honeydew, cubed",
          "1/2 cup grapes",
          "1/2 cup strawberries",
          "4 tbsp honey",
          "2 tbsp sugar",
          "4 cups water",
          "Ice cubes",
          "Mint leaves for garnish"
        ],
        koreanIngredients: [
          "수박 1컵 (깍둑썰기)",
          "멜론 1컵 (깍둑썰기)",
          "참외 1컵 (깍둑썰기)",
          "포도 1/2컵",
          "딸기 1/2컵",
          "꿀 4큰술",
          "설탕 2큰술",
          "물 4컵",
          "얼음",
          "민트 잎 (장식용)"
        ],
        instructions: [
          {
            stepName: "Prepare fruits",
            koreanStepName: "과일 준비",
            description: "Wash and cut all fruits into bite-sized pieces. Remove seeds and stems.",
            koreanDescription: "모든 과일을 씻고 한 입 크기로 썰어주세요. 씨와 꼭지를 제거해주세요."
          },
          {
            stepName: "Make syrup",
            koreanStepName: "시럽 만들기",
            description: "Mix honey and sugar with water until dissolved. Let cool completely.",
            koreanDescription: "꿀과 설탕을 물에 녹여주세요. 완전히 식혀주세요."
          },
          {
            stepName: "Assemble and serve",
            koreanStepName: "완성하고 내놓기",
            description: "Combine fruits in a large bowl, add syrup and ice. Garnish with mint leaves and serve cold.",
            koreanDescription: "큰 그릇에 과일을 넣고 시럽과 얼음을 넣어주세요. 민트 잎으로 장식하고 차가운 상태로 내놓으세요."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      },
      {
        name: "Yeon-gun Jorim",
        koreanName: "연근 조림",
        image: "/Dishes/yeon-gun-jorim.png",
        modalImage: "/modal-images/yeon-gun-jorim.jpg",
        description: "Braised lotus root with soy sauce and sesame oil. A traditional Korean side dish.",
        koreanDescription: "간장과 참기름으로 조린 연근. 전통적인 한국 반찬입니다.",
        cookingTime: "40 mins",
        koreanCookingTime: "40분",
        categories: ["Side Dish", "Vegetable"],
        koreanCategories: ["반찬", "채소"],
        timePortion: "40 mins • 4 servings",
        koreanTimePortion: "40분 • 4인분",
        ingredients: [
          "2 lotus roots (about 400g)",
          "3 tbsp soy sauce",
          "2 tbsp sugar",
          "1 tbsp sesame oil",
          "1 tbsp rice wine",
          "2 cloves garlic, minced",
          "1 tsp ginger, grated",
          "1 tbsp sesame seeds",
          "1 green onion, chopped"
        ],
        koreanIngredients: [
          "연근 2개 (약 400g)",
          "간장 3큰술",
          "설탕 2큰술",
          "참기름 1큰술",
          "청주 1큰술",
          "다진 마늘 2쪽",
          "간 생강 1작은술",
          "깨 1큰술",
          "썬 대파 1대"
        ],
        instructions: [
          {
            stepName: "Prepare lotus root",
            koreanStepName: "연근 준비",
            description: "Peel and slice lotus root into 1/4-inch rounds. Soak in vinegar water to prevent browning.",
            koreanDescription: "연근을 껍질을 벗기고 0.5cm 두께로 썰어주세요. 갈변 방지를 위해 식초물에 담가주세요."
          },
          {
            stepName: "Make braising sauce",
            koreanStepName: "조림 양념 만들기",
            description: "Mix soy sauce, sugar, sesame oil, rice wine, garlic, and ginger in a bowl.",
            koreanDescription: "간장, 설탕, 참기름, 청주, 마늘, 생강을 그릇에 넣고 섞어주세요."
          },
          {
            stepName: "Braise and finish",
            koreanStepName: "조리기",
            description: "Cook lotus root with sauce over medium heat for 30 minutes until tender. Garnish with sesame seeds and green onion.",
            koreanDescription: "연근을 양념과 함께 중불에서 30분간 부드러워질 때까지 조려주세요. 깨와 대파로 장식해 완성하세요."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      },
      {
        name: "Cucumber Side Dish",
        koreanName: "오이무침",
        image: "/Dishes/cucumber-side-dish.png",
        modalImage: "/modal-images/cucumber-side-dish.jpg",
        description: "Fresh cucumber salad with vinegar and sesame oil. A simple and refreshing Korean side dish.",
        koreanDescription: "식초와 참기름으로 만든 신선한 오이 무침. 간단하고 상쾌한 한국 반찬입니다.",
        cookingTime: "5 mins",
        koreanCookingTime: "5분",
        categories: ["Side Dish", "Vegetable"],
        koreanCategories: ["반찬", "채소"],
        timePortion: "5 mins • 4 servings",
        koreanTimePortion: "5분 • 4인분",
        ingredients: [
          "2 cucumbers",
          "1 tsp salt",
          "2 tbsp vinegar",
          "1 tbsp sesame oil",
          "1 tsp sugar",
          "1 clove garlic, minced",
          "1 tsp sesame seeds",
          "1 green onion, chopped"
        ],
        koreanIngredients: [
          "오이 2개",
          "소금 1작은술",
          "식초 2큰술",
          "참기름 1큰술",
          "설탕 1작은술",
          "다진 마늘 1쪽",
          "깨 1작은술",
          "썬 대파 1대"
        ],
        instructions: [
          {
            stepName: "Prepare cucumber",
            koreanStepName: "오이 준비",
            description: "Wash and slice cucumbers thinly. Sprinkle with salt and let sit for 10 minutes to draw out water.",
            koreanDescription: "오이를 씻고 얇게 썰어주세요. 소금을 뿌리고 10분간 두어 물기를 빼주세요."
          },
          {
            stepName: "Make dressing",
            koreanStepName: "양념 만들기",
            description: "Mix vinegar, sesame oil, sugar, garlic, and sesame seeds in a bowl.",
            koreanDescription: "식초, 참기름, 설탕, 마늘, 깨를 그릇에 넣고 섞어주세요."
          },
          {
            stepName: "Mix and serve",
            koreanStepName: "섞고 내놓기",
            description: "Squeeze excess water from cucumbers, add dressing and green onion. Mix well and serve immediately.",
            koreanDescription: "오이의 물기를 짜고 양념과 대파를 넣어주세요. 잘 섞어 바로 내놓으세요."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      },
      {
        name: "Kimchi",
        koreanName: "김치",
        image: "/Dishes/kimchi.png",
        modalImage: "/modal-images/kimchi.jpg",
        description: "Fermented napa cabbage with spicy seasoning. The essential Korean side dish and condiment.",
        koreanDescription: "매운 양념으로 발효시킨 배추김치. 한국의 필수 반찬이자 양념입니다.",
        cookingTime: "2-3hours",
        koreanCookingTime: "2-3시간",
        categories: ["Kimchi & Pickle", "Side Dish"],
        koreanCategories: ["김치 & 절임", "반찬"],
        timePortion: "2-3 hours • 8 servings",
        koreanTimePortion: "2-3시간 • 8인분",
        ingredients: [
          "1 large napa cabbage (2kg)",
          "1/2 cup coarse sea salt",
          "1/4 cup gochugaru (Korean red pepper flakes)",
          "2 tbsp fish sauce",
          "1 tbsp salted shrimp",
          "1/4 cup garlic, minced",
          "1 tbsp ginger, grated",
          "1/4 cup green onions, chopped",
          "1/4 cup radish, julienned",
          "1 tbsp sugar"
        ],
        koreanIngredients: [
          "배추 1포기 (2kg)",
          "굵은 소금 1/2컵",
          "고춧가루 1/4컵",
          "액젓 2큰술",
          "새우젓 1큰술",
          "다진 마늘 1/4컵",
          "간 생강 1큰술",
          "썬 대파 1/4컵",
          "채썬 무 1/4컵",
          "설탕 1큰술"
        ],
        instructions: [
          {
            stepName: "Salt the cabbage",
            koreanStepName: "배추 소금 절이기",
            description: "Cut cabbage into quarters and salt generously. Let sit for 2 hours, turning every 30 minutes.",
            koreanDescription: "배추를 4등분하고 소금을 충분히 뿌려주세요. 30분마다 뒤집어가며 2시간 절여주세요."
          },
          {
            stepName: "Make kimchi paste",
            koreanStepName: "김치 양념 만들기",
            description: "Mix gochugaru, fish sauce, salted shrimp, garlic, ginger, green onions, radish, and sugar.",
            koreanDescription: "고춧가루, 액젓, 새우젓, 마늘, 생강, 대파, 무, 설탕을 섞어 양념을 만드세요."
          },
          {
            stepName: "Stuff and ferment",
            koreanStepName: "양념 넣고 발효시키기",
            description: "Rinse salted cabbage and stuff with kimchi paste between leaves. Store in airtight container for 2-3 days at room temperature.",
            koreanDescription: "절인 배추를 헹구고 잎 사이사이에 김치 양념을 넣어주세요. 밀폐용기에 담아 실온에서 2-3일 발효시키세요."
          }
        ],
        recipeUrl: "https://youtu.be/naS9csQ4inA?si=0uEIpOEBd0zfiEcr"
      }
    ]
  },
  {
    name: "Pocha Night",
    background: "/Themes/pocha.jpg",
    video: "/Videos/pocha-night.mp4",
    sound: "/Sounds/pocha-night.mp3",
    dishes: [
      {
        name: "Eomuk Skewer",
        koreanName: "어묵 꼬치",
        image: "/Dishes/eomuk-skewer.png",
        modalImage: "/modal-images/eomuk-skewer.jpg",
        description: "Fish cake skewers in hot broth. A classic Korean street food snack.",
        koreanDescription: "뜨거운 국물에 담긴 어묵 꼬치. 한국의 대표적인 길거리 간식입니다.",
        cookingTime: "10 mins",
        koreanCookingTime: "10분",
        categories: ["Snack", "Seafood"],
        koreanCategories: ["간식", "해산물"],
        timePortion: "10 mins • 2-3 servings",
        koreanTimePortion: "10분 • 2-3인분",
        ingredients: [
          "200g fish cakes (eomuk)",
          "4 cups water",
          "1/2 onion, sliced",
          "2 green onions, cut into 2-inch pieces",
          "2 tbsp soy sauce",
          "1 tbsp fish sauce",
          "1 tsp sugar",
          "1 tsp minced garlic",
          "1/2 tsp black pepper",
          "Wooden skewers"
        ],
        koreanIngredients: [
          "어묵 200g",
          "물 4컵",
          "양파 1/2개 (썰어서)",
          "대파 2대 (5cm 길이로 자르기)",
          "간장 2큰술",
          "액젓 1큰술",
          "설탕 1작은술",
          "다진 마늘 1작은술",
          "후추 1/2작은술",
          "나무 꼬치"
        ],
        instructions: [
          {
            stepName: "Prepare fish cakes",
            koreanStepName: "어묵 준비",
            description: "Cut fish cakes into bite-sized pieces and thread onto wooden skewers.",
            koreanDescription: "어묵을 한 입 크기로 자르고 나무 꼬치에 꽂아주세요."
          },
          {
            stepName: "Make broth",
            koreanStepName: "국물 만들기",
            description: "In a pot, combine water, soy sauce, fish sauce, sugar, garlic, and black pepper. Bring to a boil.",
            koreanDescription: "냄비에 물, 간장, 액젓, 설탕, 마늘, 후추를 넣고 끓여주세요."
          },
          {
            stepName: "Cook skewers",
            koreanStepName: "꼬치 끓이기",
            description: "Add fish cake skewers, onion, and green onions to the boiling broth. Simmer for 5-7 minutes until heated through.",
            koreanDescription: "끓는 국물에 어묵 꼬치, 양파, 대파를 넣고 5-7분간 끓여주세요."
          },
          {
            stepName: "Serve hot",
            koreanStepName: "뜨겁게 내놓기",
            description: "Serve immediately in bowls with the hot broth. Perfect for cold weather.",
            koreanDescription: "뜨거운 국물과 함께 바로 내놓으세요. 추운 날씨에 완벽합니다."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      },
      {
        name: "Gyeran Mari",
        koreanName: "계란말이",
        image: "/Dishes/gyeran-mari.png",
        modalImage: "/modal-images/gyeran-mari.jpg",
        description: "Rolled omelette with vegetables and cheese. A simple and delicious Korean egg dish.",
        koreanDescription: "채소와 치즈가 들어간 계란말이. 간단하고 맛있는 한국 계란 요리입니다.",
        cookingTime: "10 mins",
        koreanCookingTime: "10분",
        categories: ["Side Dish", "Entree"],
        koreanCategories: ["반찬", "메인 요리"],
        timePortion: "10 mins • 2-3 servings",
        koreanTimePortion: "10분 • 2-3인분",
        ingredients: [
          "4 eggs",
          "1/4 cup milk",
          "1/2 cup shredded cheese",
          "1/4 cup carrots, julienned",
          "1/4 cup spinach, chopped",
          "2 green onions, chopped",
          "1 tbsp butter",
          "Salt and pepper to taste",
          "1 tsp sesame oil"
        ],
        koreanIngredients: [
          "계란 4개",
          "우유 1/4컵",
          "치즈 1/2컵 (채썰기)",
          "당근 1/4컵 (채썰기)",
          "시금치 1/4컵 (썰어서)",
          "대파 2대 (썰어서)",
          "버터 1큰술",
          "소금, 후추 (맛대로)",
          "참기름 1작은술"
        ],
        instructions: [
          {
            stepName: "Prepare ingredients",
            koreanStepName: "재료 준비",
            description: "Beat eggs with milk, salt, and pepper. Prepare all vegetables by cutting them into small pieces.",
            koreanDescription: "계란을 우유, 소금, 후추와 함께 풀어주세요. 모든 채소를 작은 크기로 자르세요."
          },
          {
            stepName: "Cook vegetables",
            koreanStepName: "채소 볶기",
            description: "In a pan, sauté carrots and spinach with a little butter until softened. Set aside.",
            koreanDescription: "팬에서 당근과 시금치를 버터를 조금 넣고 부드러워질 때까지 볶아주세요. 따로 보관하세요."
          },
          {
            stepName: "Make omelette",
            koreanStepName: "계란말이 만들기",
            description: "Heat butter in a pan, pour in half the egg mixture. Add vegetables and cheese, then roll from one side. Repeat with remaining mixture.",
            koreanDescription: "팬에 버터를 녹이고 계란물의 절반을 넣어주세요. 채소와 치즈를 넣고 한쪽에서 말아주세요. 나머지 반으로도 반복하세요."
          },
          {
            stepName: "Finish and serve",
            koreanStepName: "완성하고 내놓기",
            description: "Drizzle with sesame oil, cut into bite-sized pieces, and serve immediately.",
            koreanDescription: "참기름을 뿌리고 한 입 크기로 자른 후 바로 내놓으세요."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      },
      {
        name: "Sundae",
        koreanName: "순대",
        image: "/Dishes/sun-dae.png",
        modalImage: "/modal-images/sundae.jpg",
        description: "Korean blood sausage with glass noodles and vegetables. A traditional Korean street food.",
        koreanDescription: "당면과 채소가 들어간 한국 순대. 전통적인 한국 길거리 음식입니다.",
        cookingTime: "60 mins",
        koreanCookingTime: "60분",
        categories: ["Snack", "Main Dish"],
        koreanCategories: ["간식", "메인 요리"],
        timePortion: "60 mins • 4-6 servings",
        koreanTimePortion: "60분 • 4-6인분",
        ingredients: [
          "1 kg pork intestines (cleaned)",
          "200g sweet potato noodles (dangmyeon)",
          "1 cup cooked rice",
          "1/2 cup bean sprouts",
          "1/2 cup cabbage, chopped",
          "1/4 cup carrots, julienned",
          "1/4 cup green onions, chopped",
          "2 tbsp soy sauce",
          "1 tbsp sesame oil",
          "1 tsp minced garlic",
          "1 tsp salt",
          "1/2 tsp black pepper",
          "Kitchen twine"
        ],
        koreanIngredients: [
          "돼지 창자 1kg (정리된 것)",
          "당면 200g",
          "밥 1컵",
          "콩나물 1/2컵",
          "배추 1/2컵 (썰어서)",
          "당근 1/4컵 (채썰기)",
          "대파 1/4컵 (썰어서)",
          "간장 2큰술",
          "참기름 1큰술",
          "다진 마늘 1작은술",
          "소금 1작은술",
          "후추 1/2작은술",
          "실"
        ],
        instructions: [
          {
            stepName: "Prepare intestines",
            koreanStepName: "창자 준비",
            description: "Thoroughly clean pork intestines with salt and vinegar. Rinse well and set aside.",
            koreanDescription: "돼지 창자를 소금과 식초로 깨끗이 씻어주세요. 잘 헹구고 보관하세요."
          },
          {
            stepName: "Make filling",
            koreanStepName: "소 만들기",
            description: "Mix cooked rice, bean sprouts, cabbage, carrots, green onions, soy sauce, sesame oil, garlic, salt, and pepper in a bowl.",
            koreanDescription: "밥, 콩나물, 배추, 당근, 대파, 간장, 참기름, 마늘, 소금, 후추를 그릇에 넣고 섞어주세요."
          },
          {
            stepName: "Stuff intestines",
            koreanStepName: "창자에 소 넣기",
            description: "Carefully stuff the intestines with the filling mixture. Tie the ends with kitchen twine.",
            koreanDescription: "창자에 소를 조심스럽게 넣어주세요. 끝을 실로 묶어주세요."
          },
          {
            stepName: "Cook sundae",
            koreanStepName: "순대 끓이기",
            description: "Boil water in a large pot, add sundae and simmer for 45-50 minutes until cooked through. Serve with dipping sauce.",
            koreanDescription: "큰 냄비에 물을 끓이고 순대를 넣어 45-50분간 끓여주세요. 찍어먹는 소스와 함께 내놓으세요."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      },
      {
        name: "Budae Jjigae",
        koreanName: "부대찌개",
        image: "/Dishes/bu-dae-jjigae.png",
        modalImage: "/modal-images/bu-dae-jjigae.jpg",
        description: "Army stew with spam, hot dogs, and vegetables in spicy broth. A fusion Korean dish.",
        koreanDescription: "스팸, 소시지, 채소가 들어간 매운 부대찌개. 퓨전 한국 요리입니다.",
        cookingTime: "30 mins",
        koreanCookingTime: "30분",
        categories: ["Stew & Soup", "Main Dish"],
        koreanCategories: ["찌개", "메인 요리"],
        timePortion: "30 mins • 4-6 servings",
        koreanTimePortion: "30분 • 4-6인분",
        ingredients: [
          "200g spam, sliced",
          "4 hot dogs, sliced",
          "1/2 cup kimchi, chopped",
          "1/2 onion, sliced",
          "1/2 cup cabbage, chopped",
          "1/2 cup mushrooms, sliced",
          "1/4 cup green onions, chopped",
          "2 cloves garlic, minced",
          "3 tbsp gochujang",
          "1 tbsp gochugaru",
          "2 tbsp soy sauce",
          "1 tbsp sugar",
          "4 cups water",
          "1 package instant ramen noodles",
          "1/2 cup cheese, shredded"
        ],
        koreanIngredients: [
          "스팸 200g (썰어서)",
          "소시지 4개 (썰어서)",
          "김치 1/2컵 (썰어서)",
          "양파 1/2개 (썰어서)",
          "배추 1/2컵 (썰어서)",
          "버섯 1/2컵 (썰어서)",
          "대파 1/4컵 (썰어서)",
          "다진 마늘 2쪽",
          "고추장 3큰술",
          "고춧가루 1큰술",
          "간장 2큰술",
          "설탕 1큰술",
          "물 4컵",
          "라면 1개",
          "치즈 1/2컵 (채썰기)"
        ],
        instructions: [
          {
            stepName: "Prepare ingredients",
            koreanStepName: "재료 준비",
            description: "Slice spam, hot dogs, and all vegetables. Set aside.",
            koreanDescription: "스팸, 소시지, 모든 채소를 썰어주세요. 따로 보관하세요."
          },
          {
            stepName: "Make broth",
            koreanStepName: "국물 만들기",
            description: "In a large pot, combine water, gochujang, gochugaru, soy sauce, sugar, and minced garlic. Bring to a boil.",
            koreanDescription: "큰 냄비에 물, 고추장, 고춧가루, 간장, 설탕, 다진 마늘을 넣고 끓여주세요."
          },
          {
            stepName: "Add ingredients",
            koreanStepName: "재료 넣기",
            description: "Add kimchi, onion, cabbage, mushrooms, spam, and hot dogs to the boiling broth. Simmer for 15 minutes.",
            koreanDescription: "끓는 국물에 김치, 양파, 배추, 버섯, 스팸, 소시지를 넣고 15분간 끓여주세요."
          },
          {
            stepName: "Add noodles and finish",
            koreanStepName: "면 넣고 완성",
            description: "Add ramen noodles and cook for 3-4 minutes. Top with cheese and green onions. Serve hot.",
            koreanDescription: "라면을 넣고 3-4분간 끓여주세요. 치즈와 대파를 올리고 뜨겁게 내놓으세요."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      }
    ]
  },
  {
    name: "Namdaemun Market",
    video: "/Videos/namdaemunmarket.mp4",
    dishes: [
      {
        name: "Korean Street Toast",
        koreanName: "길거리 토스트",
        image: "/Dishes/korean-street-toast.png",
        modalImage: "/modal-images/korean-street-toast.jpg",
        description: "Grilled sandwich with egg, cabbage, and sweet sauce. A popular Korean street food breakfast.",
        koreanDescription: "계란, 양배추, 달콤한 소스가 들어간 구운 샌드위치. 인기 있는 한국 길거리 아침식사입니다.",
        cookingTime: "10 mins",
        koreanCookingTime: "10분",
        categories: ["Snack", "Main Dish"],
        koreanCategories: ["간식", "메인 요리"],
        timePortion: "10 mins • 1 serving",
        koreanTimePortion: "10분 • 1인분",
        ingredients: [
          "2 slices white bread",
          "1 egg",
          "1/4 cup cabbage, shredded",
          "1/4 cup carrot, julienned",
          "1 tbsp butter",
          "1 tbsp sugar",
          "1 tbsp ketchup",
          "1 tbsp mayonnaise",
          "Salt and pepper to taste"
        ],
        koreanIngredients: [
          "식빵 2장",
          "계란 1개",
          "양배추 1/4컵 (채썰기)",
          "당근 1/4컵 (채썰기)",
          "버터 1큰술",
          "설탕 1큰술",
          "케첩 1큰술",
          "마요네즈 1큰술",
          "소금, 후추 (맛대로)"
        ],
        instructions: [
          {
            stepName: "Prepare vegetables",
            koreanStepName: "야채 준비",
            description: "Shred cabbage and julienne carrot. Mix with a pinch of salt and let sit for 5 minutes.",
            koreanDescription: "양배추를 채썰고 당근을 채썰어주세요. 소금을 조금 넣고 5분간 두어주세요."
          },
          {
            stepName: "Make sweet sauce",
            koreanStepName: "달콤한 소스 만들기",
            description: "Mix ketchup, mayonnaise, and sugar in a small bowl until well combined.",
            koreanDescription: "케첩, 마요네즈, 설탕을 작은 그릇에 넣고 잘 섞어주세요."
          },
          {
            stepName: "Cook egg and vegetables",
            koreanStepName: "계란과 야채 볶기",
            description: "Beat egg and cook in a pan with butter. Add cabbage and carrot, season with salt and pepper.",
            koreanDescription: "계란을 풀고 버터를 넣은 팬에서 볶아주세요. 양배추와 당근을 넣고 소금과 후추로 간을 해주세요."
          },
          {
            stepName: "Assemble toast",
            koreanStepName: "토스트 만들기",
            description: "Place egg mixture between bread slices. Spread sweet sauce on both sides and grill until golden.",
            koreanDescription: "식빵 사이에 계란 혼합물을 넣어주세요. 양쪽에 달콤한 소스를 발라 황금색이 될 때까지 구워주세요."
          }
        ],
        recipeUrl: "https://youtu.be/3Wo5c0cCL40?si=leSqll8-tHCORAWV"
      },
      {
        name: "Tteok Skewer",
        koreanName: "떡꼬치",
        image: "/Dishes/tteok-skewer.png",
        modalImage: "/modal-images/tteok-skewer.jpg",
        description: "Grilled rice cake skewers with sweet soy sauce. A simple and delicious Korean street food.",
        koreanDescription: "달콤한 간장 소스가 발라진 구운 떡꼬치. 간단하고 맛있는 한국 길거리 음식입니다.",
        cookingTime: "15 mins",
        koreanCookingTime: "15분",
        categories: ["Snack", "Dessert"],
        koreanCategories: ["간식", "디저트"],
        timePortion: "15 mins • 4 servings",
        koreanTimePortion: "15분 • 4인분",
        ingredients: [
          "200g rice cakes (tteok)",
          "4 wooden skewers",
          "2 tbsp soy sauce",
          "1 tbsp sugar",
          "1 tbsp honey",
          "1 tbsp sesame oil",
          "1 tsp garlic, minced",
          "1 tbsp sesame seeds",
          "1 green onion, chopped"
        ],
        koreanIngredients: [
          "떡 200g",
          "나무 꼬치 4개",
          "간장 2큰술",
          "설탕 1큰술",
          "꿀 1큰술",
          "참기름 1큰술",
          "다진 마늘 1작은술",
          "깨 1큰술",
          "썬 대파 1대"
        ],
        instructions: [
          {
            stepName: "Prepare skewers",
            koreanStepName: "꼬치 준비",
            description: "Soak wooden skewers in water for 30 minutes. Thread rice cakes onto skewers.",
            koreanDescription: "나무 꼬치를 30분간 물에 담가주세요. 떡을 꼬치에 꽂아주세요."
          },
          {
            stepName: "Make sauce",
            koreanStepName: "소스 만들기",
            description: "Mix soy sauce, sugar, honey, sesame oil, and garlic in a bowl.",
            koreanDescription: "간장, 설탕, 꿀, 참기름, 마늘을 그릇에 넣고 섞어주세요."
          },
          {
            stepName: "Grill and glaze",
            koreanStepName: "구우고 글레이즈하기",
            description: "Grill rice cake skewers on medium heat for 3-4 minutes per side. Brush with sauce and continue grilling.",
            koreanDescription: "떡꼬치를 중불에서 한 면당 3-4분씩 구워주세요. 소스를 발라 계속 구워주세요."
          },
          {
            stepName: "Garnish and serve",
            koreanStepName: "장식하고 내놓기",
            description: "Sprinkle with sesame seeds and green onions. Serve hot.",
            koreanDescription: "깨와 대파를 뿌려주세요. 뜨거운 상태로 내놓으세요."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      },
      {
        name: "Mandu",
        koreanName: "만두",
        image: "/Dishes/mandu.png",
        modalImage: "/modal-images/mandu.jpg",
        description: "Korean dumplings with meat and vegetable filling. Steamed or pan-fried for delicious results.",
        koreanDescription: "고기와 채소가 들어간 한국 만두. 찌거나 구워서 맛있게 먹을 수 있습니다.",
        cookingTime: "45 mins",
        koreanCookingTime: "45분",
        categories: ["Snack", "Main Dish"],
        koreanCategories: ["간식", "메인 요리"],
        timePortion: "45 mins • 20 pieces",
        koreanTimePortion: "45분 • 20개",
        ingredients: [
          "20 dumpling wrappers",
          "200g ground pork",
          "100g cabbage, finely chopped",
          "50g bean sprouts",
          "2 green onions, chopped",
          "2 cloves garlic, minced",
          "1 tbsp soy sauce",
          "1 tbsp sesame oil",
          "1 tsp sugar",
          "1/2 tsp salt",
          "1/2 tsp black pepper",
          "1 egg"
        ],
        koreanIngredients: [
          "만두피 20장",
          "돼지고기 다진 것 200g",
          "양배추 100g (잘게 썰어서)",
          "콩나물 50g",
          "썬 대파 2대",
          "다진 마늘 2쪽",
          "간장 1큰술",
          "참기름 1큰술",
          "설탕 1작은술",
          "소금 1/2작은술",
          "후추 1/2작은술",
          "계란 1개"
        ],
        instructions: [
          {
            stepName: "Prepare filling",
            koreanStepName: "소 준비",
            description: "Mix ground pork with chopped cabbage, bean sprouts, green onions, garlic, soy sauce, sesame oil, sugar, salt, and pepper.",
            koreanDescription: "다진 돼지고기에 썬 양배추, 콩나물, 대파, 마늘, 간장, 참기름, 설탕, 소금, 후추를 넣고 섞어주세요."
          },
          {
            stepName: "Wrap dumplings",
            koreanStepName: "만두 싸기",
            description: "Place filling in center of wrapper, wet edges with egg, and fold to seal tightly.",
            koreanDescription: "만두피 중앙에 소를 넣고 가장자리에 계란을 발라 꽉 싸주세요."
          },
          {
            stepName: "Cook mandu",
            koreanStepName: "만두 조리하기",
            description: "Steam for 8-10 minutes or pan-fry until golden brown on both sides.",
            koreanDescription: "8-10분간 찌거나 양면이 황금색이 될 때까지 구워주세요."
          },
          {
            stepName: "Serve hot",
            koreanStepName: "뜨거운 상태로 내놓기",
            description: "Serve immediately with soy sauce dipping sauce and kimchi.",
            koreanDescription: "간장 찍어먹는 소스와 김치와 함께 바로 내놓으세요."
          }
        ],
        recipeUrl: "https://youtu.be/K1Spmjl9Nb4?si=BTXr4zlXKARZamHW"
      },
      {
        name: "Twigim",
        koreanName: "튀김",
        image: "/Dishes/twigim.png",
        modalImage: "/modal-images/twigim.jpg",
        description: "Assorted deep-fried vegetables and seafood. A crispy and flavorful Korean street food.",
        koreanDescription: "다양한 채소와 해산물을 튀긴 튀김. 바삭하고 맛있는 한국 길거리 음식입니다.",
        cookingTime: "20 mins",
        koreanCookingTime: "20분",
        categories: ["Deep Frying", "Snack"],
        koreanCategories: ["튀김", "간식"],
        timePortion: "20 mins • 4 servings",
        koreanTimePortion: "20분 • 4인분",
        ingredients: [
          "1 sweet potato, sliced",
          "1 zucchini, sliced",
          "1/2 cup mushrooms",
          "1/2 cup shrimp",
          "1/2 cup squid rings",
          "1 cup all-purpose flour",
          "1/2 cup cornstarch",
          "1 tsp salt",
          "1/2 tsp black pepper",
          "1 cup cold water",
          "Oil for frying"
        ],
        koreanIngredients: [
          "고구마 1개 (썰어서)",
          "애호박 1개 (썰어서)",
          "버섯 1/2컵",
          "새우 1/2컵",
          "오징어 링 1/2컵",
          "중력분 1컵",
          "옥수수전분 1/2컵",
          "소금 1작은술",
          "후추 1/2작은술",
          "차가운 물 1컵",
          "튀김용 기름"
        ],
        instructions: [
          {
            stepName: "Prepare ingredients",
            koreanStepName: "재료 준비",
            description: "Cut all vegetables into bite-sized pieces. Clean and prepare seafood.",
            koreanDescription: "모든 채소를 한 입 크기로 썰어주세요. 해산물을 씻고 준비해주세요."
          },
          {
            stepName: "Make batter",
            koreanStepName: "반죽 만들기",
            description: "Mix flour, cornstarch, salt, and pepper. Gradually add cold water until smooth batter forms.",
            koreanDescription: "밀가루, 옥수수전분, 소금, 후추를 섞어주세요. 차가운 물을 조금씩 넣어 부드러운 반죽을 만드세요."
          },
          {
            stepName: "Fry ingredients",
            koreanStepName: "재료 튀기기",
            description: "Heat oil to 350°F. Dip ingredients in batter and fry until golden brown and crispy.",
            koreanDescription: "기름을 175°C로 달구세요. 재료를 반죽에 넣고 황금색이고 바삭해질 때까지 튀겨주세요."
          },
          {
            stepName: "Drain and serve",
            koreanStepName: "기름 빼고 내놓기",
            description: "Drain on paper towels and serve immediately while hot and crispy.",
            koreanDescription: "키친타월에 올려 기름을 빼고 뜨겁고 바삭한 상태로 바로 내놓으세요."
          }
        ],
        recipeUrl: "https://youtu.be/9DZShtHkBIE?si=mkYdHavwDRvTyGnO"
      },
    
      {
        name: "Hobakjuk",
        koreanName: "호박죽",
        image: "/Dishes/hobak-juk.png",
        modalImage: "/modal-images/hobak-juk.jpg",
        description: "Pumpkin porridge with sweet rice and red beans. A healthy and comforting Korean dessert.",
        koreanDescription: "찹쌀과 팥이 들어간 호박죽. 건강하고 위로가 되는 한국 전통 디저트입니다.",
        cookingTime: "30 mins",
        koreanCookingTime: "30분",
        categories: ["Dessert", "Snack"],
        koreanCategories: ["디저트", "간식"],
        timePortion: "30 mins • 4 servings",
        koreanTimePortion: "30분 • 4인분",
        ingredients: [
          "1 small pumpkin (about 1kg)",
          "1/2 cup sweet rice",
          "1/4 cup red beans",
          "4 cups water",
          "2 tbsp sugar",
          "1 tsp salt",
          "1 tbsp sesame seeds"
        ],
        koreanIngredients: [
          "호박 1개 (약 1kg)",
          "찹쌀 1/2컵",
          "팥 1/4컵",
          "물 4컵",
          "설탕 2큰술",
          "소금 1작은술",
          "깨 1큰술"
        ],
        instructions: [
          {
            stepName: "Prepare pumpkin",
            koreanStepName: "호박 준비",
            description: "Cut pumpkin in half, remove seeds, and steam until tender. Scoop out flesh and puree.",
            koreanDescription: "호박을 반으로 자르고 씨를 제거한 후 부드러워질 때까지 찌세요. 살을 파내고 퓨레로 만들어주세요."
          },
          {
            stepName: "Cook rice and beans",
            koreanStepName: "쌀과 팥 삶기",
            description: "Soak sweet rice and red beans separately for 2 hours. Cook in water until soft.",
            koreanDescription: "찹쌀과 팥을 각각 2시간 불려주세요. 물에 넣고 부드러워질 때까지 삶아주세요."
          },
          {
            stepName: "Make porridge",
            koreanStepName: "죽 만들기",
            description: "Combine pumpkin puree, cooked rice, and beans. Add water and simmer for 15 minutes, stirring frequently.",
            koreanDescription: "호박 퓨레, 삶은 쌀, 팥을 섞어주세요. 물을 넣고 자주 저어가며 15분간 끓여주세요."
          },
          {
            stepName: "Season and serve",
            koreanStepName: "간 맞추고 내놓기",
            description: "Add sugar and salt to taste. Garnish with sesame seeds and serve warm.",
            koreanDescription: "맛에 맞게 설탕과 소금을 넣어주세요. 깨를 뿌리고 따뜻한 상태로 내놓으세요."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      }
    ]
  },
  {
    name: "Han River",
    background: "/Themes/han-gang.jpg",
    video: "/Videos/han-gang.mp4",
    sound: "/Sounds/han-gang.mp3",
    dishes: [
      {
        name: "Dosirak (Nostalgic lunch box)",
        koreanName: "옛날 도시락",
        image: "/Dishes/dosirak.png",
        modalImage: "/modal-images/dosirak.jpg",
        description: "Korean lunch box with rice, meat, and various side dishes. Perfect for picnics and outdoor dining.",
        koreanDescription: "밥과 고기, 다양한 반찬이 들어간 한국 도시락. 소풍이나 야외 식사에 완벽합니다.",
        cookingTime: "45 mins",
        koreanCookingTime: "45분",
        categories: ["Main Dish", "Side Dish"],
        koreanCategories: ["메인 요리", "반찬"],
        timePortion: "45 mins • 2 servings",
        koreanTimePortion: "45분 • 2인분",
        ingredients: [
          "2 cups cooked rice",
          "200g bulgogi (marinated beef)",
          "1/2 cup kimchi",
          "1/2 cup spinach namul",
          "1/2 cup bean sprout namul",
          "1/2 cup carrot namul",
          "2 eggs",
          "1 tbsp sesame oil",
          "1 tsp salt",
          "1 tbsp sesame seeds"
        ],
        koreanIngredients: [
          "밥 2컵",
          "불고기 200g",
          "김치 1/2컵",
          "시금치 나물 1/2컵",
          "콩나물 나물 1/2컵",
          "당근 나물 1/2컵",
          "계란 2개",
          "참기름 1큰술",
          "소금 1작은술",
          "깨 1큰술"
        ],
        instructions: [
          {
            stepName: "Prepare rice",
            koreanStepName: "밥 준비",
            description: "Cook rice and mix with sesame oil and salt. Let cool to room temperature.",
            koreanDescription: "밥을 짓고 참기름과 소금을 넣어 섞어주세요. 실온까지 식혀주세요."
          },
          {
            stepName: "Cook bulgogi",
            koreanStepName: "불고기 볶기",
            description: "Cook marinated beef in a pan until browned and cooked through.",
            koreanDescription: "양념된 소고기를 팬에서 갈색이 되고 익을 때까지 볶아주세요."
          },
          {
            stepName: "Prepare side dishes",
            koreanStepName: "반찬 준비",
            description: "Blanch spinach and bean sprouts, season with sesame oil and salt. Sauté carrots with a little oil.",
            koreanDescription: "시금치와 콩나물을 데치고 참기름과 소금으로 간을 해주세요. 당근은 기름을 조금 넣고 볶아주세요."
          },
          {
            stepName: "Make egg rolls",
            koreanStepName: "계란말이 만들기",
            description: "Beat eggs and make thin egg rolls. Cut into strips.",
            koreanDescription: "계란을 풀어 얇은 계란말이를 만들어주세요. 길게 썰어주세요."
          },
          {
            stepName: "Pack dosirak",
            koreanStepName: "도시락 포장",
            description: "Arrange rice, bulgogi, kimchi, and all side dishes in lunch boxes. Sprinkle with sesame seeds.",
            koreanDescription: "도시락통에 밥, 불고기, 김치, 모든 반찬을 예쁘게 담아주세요. 깨를 뿌려 완성하세요."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      },
      {
        name: "Gimbap",
        koreanName: "김밥",
        image: "/Dishes/gimbap.png",
        modalImage: "/modal-images/gimbap.jpg",
        description: "Korean rice rolls wrapped in seaweed with various fillings. Perfect for picnics and lunch boxes.",
        koreanDescription: "다양한 재료를 넣고 김에 싸서 만든 한국의 대표 도시락 음식. 소풍이나 도시락으로 완벽합니다.",
        cookingTime: "30 mins",
        koreanCookingTime: "30분",
        categories: ["Main Dish", "Side Dish"],
        koreanCategories: ["메인 요리", "반찬"],
        timePortion: "30 mins • 4-6 servings",
        koreanTimePortion: "30분 • 4-6인분",
        ingredients: [
          "4 sheets nori seaweed",
          "2 cups cooked short-grain rice",
          "1 tbsp sesame oil",
          "1 tsp salt",
          "4 strips pickled radish",
          "4 strips cucumber",
          "4 strips carrot",
          "4 strips egg",
          "4 strips ham or spam",
          "1 tbsp sesame seeds"
        ],
        koreanIngredients: [
          "김 4장",
          "밥 2컵",
          "참기름 1큰술",
          "소금 1작은술",
          "단무지 4줄",
          "오이 4줄",
          "당근 4줄",
          "계란 4줄",
          "햄 또는 스팸 4줄",
          "깨 1큰술"
        ],
        instructions: [
          {
            stepName: "Prepare rice",
            koreanStepName: "밥 준비",
            description: "Mix cooked rice with sesame oil and salt. Let cool slightly.",
            koreanDescription: "밥에 참기름과 소금을 넣고 섞어주세요. 살짝 식혀주세요."
          },
          {
            stepName: "Prepare fillings",
            koreanStepName: "재료 준비",
            description: "Cut all vegetables and proteins into thin strips.",
            koreanDescription: "모든 채소와 단백질을 얇게 썰어주세요."
          },
          {
            stepName: "Roll gimbap",
            koreanStepName: "김밥 말기",
            description: "Place rice on nori, add fillings, and roll tightly.",
            koreanDescription: "김에 밥을 펴고 재료를 넣어 꽉 말아주세요."
          },
          {
            stepName: "Cut and serve",
            koreanStepName: "자르고 내놓기",
            description: "Let the gimbap rest for 5 minutes, then cut into bite-sized pieces with a sharp knife. Serve immediately with pickled radish on the side.",
            koreanDescription: "김밥을 5분간 식힌 후 날카로운 칼로 한 입 크기로 자르세요. 단무지와 함께 바로 내놓으세요."
          }
        ],
        recipeUrl: "https://youtu.be/bJgz1qTa8Cg?si=dvrbMd69eBFAjWbg"
      },
      {
        name: "Lemon Cheong Soda",
        koreanName: "레몬청 소다",
        image: "/Dishes/lemon-cheong-soda.png",
        modalImage: "/modal-images/lemon-cheong-soda.jpg",
        description: "Refreshing lemon soda with homemade lemon syrup. A perfect drink for outdoor activities.",
        koreanDescription: "집에서 만든 레몬청으로 만든 상쾌한 레몬 소다. 야외 활동에 완벽한 음료입니다.",
        cookingTime: "10 mins",
        koreanCookingTime: "10분",
        categories: ["Beverage", "Dessert"],
        koreanCategories: ["음료", "디저트"],
        timePortion: "10 mins • 2 servings",
        koreanTimePortion: "10분 • 2인분",
        ingredients: [
          "2 lemons, sliced",
          "1/2 cup sugar",
          "1/4 cup honey",
          "2 cups sparkling water",
          "Ice cubes",
          "Mint leaves for garnish"
        ],
        koreanIngredients: [
          "레몬 2개 (썰어서)",
          "설탕 1/2컵",
          "꿀 1/4컵",
          "탄산수 2컵",
          "얼음",
          "민트 잎 (장식용)"
        ],
        instructions: [
          {
            stepName: "Make lemon syrup",
            koreanStepName: "레몬청 만들기",
            description: "Layer lemon slices with sugar and honey in a jar. Let sit for 2-3 hours until syrup forms.",
            koreanDescription: "유리병에 레몬 슬라이스와 설탕, 꿀을 층층이 쌓아주세요. 시럽이 생길 때까지 2-3시간 두세요."
          },
          {
            stepName: "Prepare soda",
            koreanStepName: "소다 준비",
            description: "Mix lemon syrup with sparkling water. Add ice cubes and stir gently.",
            koreanDescription: "레몬청과 탄산수를 섞어주세요. 얼음을 넣고 살짝 저어주세요."
          },
          {
            stepName: "Serve and enjoy",
            koreanStepName: "내놓고 즐기기",
            description: "Garnish with mint leaves and serve immediately while cold and bubbly.",
            koreanDescription: "민트 잎으로 장식하고 차갑고 탄산이 있는 상태로 바로 내놓으세요."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      },
      {
        name: "Salad Jar",
        koreanName: "샐러드 병",
        image: "/Dishes/salad-jar.png",
        modalImage: "/modal-images/salad-jar.jpg",
        description: "Fresh vegetable salad in a jar with Korean dressing. A healthy and portable meal option.",
        koreanDescription: "한국식 드레싱이 들어간 신선한 야채 샐러드 자르. 건강하고 휴대하기 좋은 식사 옵션입니다.",
        cookingTime: "15 mins",
        koreanCookingTime: "15분",
        categories: ["Side Dish", "Vegetable"],
        koreanCategories: ["반찬", "채소"],
        timePortion: "15 mins • 2 servings",
        koreanTimePortion: "15분 • 2인분",
        ingredients: [
          "2 cups mixed greens",
          "1 cucumber, sliced",
          "1 carrot, julienned",
          "1/2 cup cherry tomatoes",
          "1/4 cup red cabbage, shredded",
          "1/4 cup radish, julienned",
          "2 tbsp sesame oil",
          "1 tbsp soy sauce",
          "1 tbsp vinegar",
          "1 tsp sugar",
          "1 tbsp sesame seeds"
        ],
        koreanIngredients: [
          "믹스 그린 2컵",
          "오이 1개 (썰어서)",
          "당근 1개 (채썰기)",
          "체리 토마토 1/2컵",
          "적양배추 1/4컵 (채썰기)",
          "무 1/4컵 (채썰기)",
          "참기름 2큰술",
          "간장 1큰술",
          "식초 1큰술",
          "설탕 1작은술",
          "깨 1큰술"
        ],
        instructions: [
          {
            stepName: "Prepare vegetables",
            koreanStepName: "채소 준비",
            description: "Wash and cut all vegetables. Slice cucumber, julienne carrot and radish, halve cherry tomatoes.",
            koreanDescription: "모든 야채를 씻고 썰어주세요. 오이는 썰고, 당근과 무는 채썰기, 체리 토마토는 반으로 자르세요."
          },
          {
            stepName: "Make Korean dressing",
            koreanStepName: "한국식 드레싱 만들기",
            description: "Mix sesame oil, soy sauce, vinegar, sugar, and sesame seeds in a small bowl.",
            koreanDescription: "참기름, 간장, 식초, 설탕, 깨를 작은 그릇에 넣고 섞어주세요."
          },
          {
            stepName: "Layer in jar",
            koreanStepName: "병에 채소 층층이 담기",
            description: "Layer vegetables in jar starting with dressing at bottom, then sturdy vegetables, ending with greens on top.",
            koreanDescription: "자르에 드레싱을 바닥에 넣고, 단단한 야채부터 시작해서 마지막에 그린을 올려 층층이 담아주세요."
          },
          {
            stepName: "Store and serve",
            koreanStepName: "보관하고 내놓기",
            description: "Refrigerate for at least 30 minutes. Shake well before serving and enjoy fresh.",
            koreanDescription: "최소 30분간 냉장고에 보관하세요. 내놓기 전에 잘 흔들어 섞어 신선하게 즐기세요."
          }
        ],
        recipeUrl: "https://youtu.be/rDXJ4ieO_G4"
      },
      {
        name: "Potato Salad Sandwich",
        koreanName: "감자 샐러드 샌드위치",
        image: "/Dishes/potato-salada-sandwich.png",
        modalImage: "/modal-images/potato-salada-sandwich.jpg",
        description: "Creamy potato salad sandwich with fresh vegetables. A perfect picnic sandwich with Korean twist.",
        koreanDescription: "신선한 야채가 들어간 크림 감자 샐러드 샌드위치. 한국식 변주가 가미된 완벽한 소풍 샌드위치입니다.",
        cookingTime: "25 mins",
        koreanCookingTime: "25분",
        categories: ["Main Dish", "Side Dish"],
        koreanCategories: ["메인 요리", "반찬"],
        timePortion: "25 mins • 4 servings",
        koreanTimePortion: "25분 • 4인분",
        ingredients: [
          "4 large potatoes",
          "1/2 cup mayonnaise",
          "2 tbsp mustard",
          "1/4 cup pickles, diced",
          "1/4 cup celery, diced",
          "1/4 cup red onion, diced",
          "2 hard-boiled eggs, diced",
          "1 tsp salt",
          "1/2 tsp black pepper",
          "8 slices bread",
          "Lettuce leaves"
        ],
        koreanIngredients: [
          "감자 4개 (큰 것)",
          "마요네즈 1/2컵",
          "머스타드 2큰술",
          "피클 1/4컵 (깍둑썰기)",
          "셀러리 1/4컵 (깍둑썰기)",
          "적양파 1/4컵 (깍둑썰기)",
          "삶은 계란 2개 (깍둑썰기)",
          "소금 1작은술",
          "후추 1/2작은술",
          "식빵 8장",
          "상추 잎"
        ],
        instructions: [
          {
            stepName: "Cook potatoes",
            koreanStepName: "감자 삶기",
            description: "Boil potatoes until tender. Peel and dice into small cubes. Let cool completely.",
            koreanDescription: "감자를 부드러워질 때까지 삶아주세요. 껍질을 벗기고 작은 깍둑으로 썰어주세요. 완전히 식혀주세요."
          },
          {
            stepName: "Make potato salad",
            koreanStepName: "감자 샐러드 만들기",
            description: "Mix cooled potatoes with mayonnaise, mustard, pickles, celery, onion, eggs, salt, and pepper.",
            koreanDescription: "식힌 감자에 마요네즈, 머스타드, 피클, 셀러리, 양파, 계란, 소금, 후추를 넣고 섞어주세요."
          },
          {
            stepName: "Assemble sandwiches",
            koreanStepName: "샌드위치 만들기",
            description: "Layer lettuce and potato salad between bread slices. Cut in half and serve immediately.",
            koreanDescription: "식빵 사이에 상추와 감자 샐러드를 넣어주세요. 반으로 자르고 바로 내놓으세요."
          }
        ],
        recipeUrl: "https://youtu.be/L6zTVBHJ9T0"
      }
    ]
  },
  {
    name: "Chuseok",
    background: "/Themes/chuseok.jpg",
    dishes: [
      {
        name: "Nabak Kimchi",
        koreanName: "나박김치",
        image: "/Dishes/nabakkimchi.png",
        modalImage: "/modal-images/nabakkimchi.jpg",
        description: "Refreshing water kimchi with radish and cabbage in light brine. A cooling side dish for Chuseok feasts.",
        koreanDescription: "무와 배추를 넣은 시원한 물김치. 추석 잔치에 어울리는 시원한 반찬입니다.",
        cookingTime: "60 mins",
        koreanCookingTime: "60분",
        categories: ["Kimchi & Pickle", "Side Dish"],
        koreanCategories: ["김치 & 절임", "반찬"],
        timePortion: "60 mins • 6-8 servings",
        koreanTimePortion: "60분 • 6-8인분",
        ingredients: [
          "1 medium napa cabbage",
          "1 large Korean radish (mu)",
          "1/2 cup salt",
          "4 cups water",
          "1/2 cup Korean red pepper powder",
          "1/4 cup fish sauce",
          "2 tbsp minced garlic",
          "1 tbsp minced ginger",
          "2 green onions, chopped",
          "1/2 Asian pear, julienned",
          "1 tbsp sugar",
          "1 tsp salt"
        ],
        koreanIngredients: [
          "배추 1개 (중간 크기)",
          "무 1개 (큰 것)",
          "소금 1/2컵",
          "물 4컵",
          "고춧가루 1/2컵",
          "액젓 1/4컵",
          "다진 마늘 2큰술",
          "다진 생강 1큰술",
          "대파 2대 (썰어서)",
          "배 1/2개 (채썰기)",
          "설탕 1큰술",
          "소금 1작은술"
        ],
        instructions: [
          {
            stepName: "Prepare vegetables",
            koreanStepName: "채소 준비",
            description: "Cut cabbage into bite-sized pieces and radish into thin slices. Soak in salt water for 30 minutes.",
            koreanDescription: "배추를 한 입 크기로 자르고 무는 얇게 썰어주세요. 소금물에 30분간 담가주세요."
          },
          {
            stepName: "Make seasoning paste",
            koreanStepName: "양념 만들기",
            description: "Mix red pepper powder, fish sauce, garlic, ginger, green onions, pear, sugar, and salt in a bowl.",
            koreanDescription: "고춧가루, 액젓, 마늘, 생강, 대파, 배, 설탕, 소금을 그릇에 넣고 섞어주세요."
          },
          {
            stepName: "Combine and mix",
            koreanStepName: "섞어서 버무리기",
            description: "Drain vegetables and mix with seasoning paste. Massage gently to distribute seasoning evenly.",
            koreanDescription: "채소의 물기를 빼고 양념과 섞어주세요. 양념이 고르게 배도록 살살 버무려주세요."
          },
          {
            stepName: "Ferment and serve",
            koreanStepName: "숙성하고 내놓기",
            description: "Place in a container, add water to cover, and let ferment at room temperature for 1-2 days. Serve chilled.",
            koreanDescription: "용기에 담고 물을 넣어 채운 후 실온에서 1-2일 숙성시키세요. 차갑게 해서 내놓으세요."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      },
      {
        name: "Modeum Jeon",
        koreanName: "모듬전",
        image: "/Dishes/modeumjeon.png",
        modalImage: "/modal-images/modeumjeon.jpg",
        description: "Assorted Korean pancakes with vegetables, meat, and seafood. Essential for Chuseok ancestral rituals.",
        koreanDescription: "채소, 고기, 해산물이 들어간 다양한 전. 추석 차례상에 꼭 필요한 음식입니다.",
        cookingTime: "45 mins",
        koreanCookingTime: "45분",
        categories: ["Side Dish", "Entree"],
        koreanCategories: ["반찬", "메인 요리"],
        timePortion: "45 mins • 6-8 servings",
        koreanTimePortion: "45분 • 6-8인분",
        ingredients: [
          "1 cup all-purpose flour",
          "2 eggs",
          "1/2 cup water",
          "1/2 tsp salt",
          "1/4 cup zucchini, sliced",
          "1/4 cup carrots, julienned",
          "1/4 cup mushrooms, sliced",
          "1/4 cup green onions, chopped",
          "100g beef, thinly sliced",
          "100g shrimp, cleaned",
          "2 tbsp soy sauce",
          "1 tbsp sesame oil",
          "1 tsp minced garlic",
          "Vegetable oil for frying"
        ],
        koreanIngredients: [
          "중력분 1컵",
          "계란 2개",
          "물 1/2컵",
          "소금 1/2작은술",
          "애호박 1/4컵 (썰어서)",
          "당근 1/4컵 (채썰기)",
          "버섯 1/4컵 (썰어서)",
          "대파 1/4컵 (썰어서)",
          "소고기 100g (얇게 썰어서)",
          "새우 100g (정리한 것)",
          "간장 2큰술",
          "참기름 1큰술",
          "다진 마늘 1작은술",
          "식용유 (튀김용)"
        ],
        instructions: [
          {
            stepName: "Make batter",
            koreanStepName: "반죽 만들기",
            description: "Mix flour, eggs, water, and salt to make a smooth batter. Let rest for 10 minutes.",
            koreanDescription: "밀가루, 계란, 물, 소금을 섞어 부드러운 반죽을 만드세요. 10분간 휴지시켜주세요."
          },
          {
            stepName: "Prepare ingredients",
            koreanStepName: "재료 준비",
            description: "Slice all vegetables and meat thinly. Marinate beef with soy sauce, sesame oil, and garlic.",
            koreanDescription: "모든 채소와 고기를 얇게 썰어주세요. 소고기는 간장, 참기름, 마늘로 양념해주세요."
          },
          {
            stepName: "Cook pancakes",
            koreanStepName: "전 부치기",
            description: "Heat oil in a pan. Dip ingredients in batter and fry until golden brown on both sides. Cook in batches.",
            koreanDescription: "팬에 기름을 두르고 재료를 반죽에 담가 양면이 황금색이 될 때까지 부쳐주세요. 여러 번에 나누어 부치세요."
          },
          {
            stepName: "Serve and arrange",
            koreanStepName: "내놓고 정리하기",
            description: "Arrange different types of jeon on a platter. Serve with soy sauce dipping sauce.",
            koreanDescription: "다양한 전을 접시에 예쁘게 담아주세요. 간장 찍어먹는 소스와 함께 내놓으세요."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      },
      {
        name: "Galbijjim",
        koreanName: "갈비찜",
        image: "/Dishes/galbijjim.png",
        modalImage: "/modal-images/galbijjim.jpg",
        description: "Braised beef short ribs with vegetables in sweet soy sauce. A festive centerpiece for Chuseok table.",
        koreanDescription: "달콤한 간장 소스에 채소와 함께 끓인 갈비찜. 추석 상의 중심이 되는 음식입니다.",
        cookingTime: "90 mins",
        koreanCookingTime: "90분",
        categories: ["Main Dish", "Entree"],
        koreanCategories: ["메인 요리", "메인 요리"],
        timePortion: "90 mins • 6-8 servings",
        koreanTimePortion: "90분 • 6-8인분",
        ingredients: [
          "1.5kg beef short ribs",
          "1/2 cup soy sauce",
          "1/4 cup sugar",
          "2 tbsp honey",
          "2 tbsp sesame oil",
          "3 tbsp minced garlic",
          "1 tbsp minced ginger",
          "1/2 cup water",
          "2 carrots, cut into chunks",
          "2 potatoes, cut into chunks",
          "1 onion, sliced",
          "1/2 cup chestnuts",
          "1/2 cup jujubes",
          "2 green onions, chopped",
          "1 tbsp sesame seeds"
        ],
        koreanIngredients: [
          "소갈비 1.5kg",
          "간장 1/2컵",
          "설탕 1/4컵",
          "꿀 2큰술",
          "참기름 2큰술",
          "다진 마늘 3큰술",
          "다진 생강 1큰술",
          "물 1/2컵",
          "당근 2개 (토막내기)",
          "감자 2개 (토막내기)",
          "양파 1개 (썰어서)",
          "밤 1/2컵",
          "대추 1/2컵",
          "대파 2대 (썰어서)",
          "깨 1큰술"
        ],
        instructions: [
          {
            stepName: "Prepare ribs",
            koreanStepName: "갈비 준비",
            description: "Soak ribs in cold water for 30 minutes to remove blood. Drain and pat dry.",
            koreanDescription: "갈비를 찬물에 30분간 담가 핏물을 제거하세요. 물기를 빼고 수건으로 닦아주세요."
          },
          {
            stepName: "Make marinade",
            koreanStepName: "양념 만들기",
            description: "Mix soy sauce, sugar, honey, sesame oil, garlic, and ginger in a bowl.",
            koreanDescription: "간장, 설탕, 꿀, 참기름, 마늘, 생강을 그릇에 넣고 섞어주세요."
          },
          {
            stepName: "Marinate and cook",
            koreanStepName: "양념하고 끓이기",
            description: "Coat ribs with marinade and let sit for 30 minutes. Add water and simmer for 60 minutes, then add vegetables and cook for 20 more minutes.",
            koreanDescription: "갈비에 양념을 발라 30분간 재워주세요. 물을 넣고 60분간 끓인 후 채소를 넣고 20분 더 끓여주세요."
          },
          {
            stepName: "Finish and serve",
            koreanStepName: "완성하고 내놓기",
            description: "Garnish with green onions and sesame seeds. Serve hot as the centerpiece of the Chuseok table.",
            koreanDescription: "대파와 깨를 올려 장식하세요. 추석 상의 중심이 되도록 뜨겁게 내놓으세요."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      },
      {
        name: "Gujeolpan",
        koreanName: "구절판",
        image: "/Dishes/gujeolpan.png",
        modalImage: "/modal-images/gujeolpan.jpg",
        description: "Nine-sectioned dish with colorful vegetables and meat wrapped in thin crepes. A royal Korean delicacy.",
        koreanDescription: "다양한 채소와 고기를 얇은 전병에 싸서 아홉 칸에 담은 요리. 궁중의 진수성찬입니다.",
        cookingTime: "60 mins",
        koreanCookingTime: "60분",
        categories: ["Main Dish", "Entree"],
        koreanCategories: ["메인 요리", "메인 요리"],
        timePortion: "60 mins • 8-10 servings",
        koreanTimePortion: "60분 • 8-10인분",
        ingredients: [
          "2 cups all-purpose flour",
          "3 eggs",
          "1 cup water",
          "1/2 tsp salt",
          "1/2 cup carrots, julienned",
          "1/2 cup cucumber, julienned",
          "1/2 cup spinach, blanched",
          "1/2 cup bean sprouts, blanched",
          "1/2 cup mushrooms, julienned",
          "1/2 cup beef, julienned",
          "1/2 cup egg strips",
          "2 tbsp soy sauce",
          "1 tbsp sesame oil",
          "1 tsp sugar",
          "1 tsp minced garlic",
          "Vegetable oil for cooking"
        ],
        koreanIngredients: [
          "중력분 2컵",
          "계란 3개",
          "물 1컵",
          "소금 1/2작은술",
          "당근 1/2컵 (채썰기)",
          "오이 1/2컵 (채썰기)",
          "시금치 1/2컵 (데친 것)",
          "콩나물 1/2컵 (데친 것)",
          "버섯 1/2컵 (채썰기)",
          "소고기 1/2컵 (채썰기)",
          "계란지단 1/2컵",
          "간장 2큰술",
          "참기름 1큰술",
          "설탕 1작은술",
          "다진 마늘 1작은술",
          "식용유 (조리용)"
        ],
        instructions: [
          {
            stepName: "Make crepes",
            koreanStepName: "전병 만들기",
            description: "Mix flour, eggs, water, and salt to make thin crepe batter. Cook thin crepes in a pan and set aside.",
            koreanDescription: "밀가루, 계란, 물, 소금을 섞어 얇은 전병 반죽을 만드세요. 팬에서 얇은 전병을 부치고 보관하세요."
          },
          {
            stepName: "Prepare fillings",
            koreanStepName: "소 준비",
            description: "Julienne all vegetables and meat. Cook each ingredient separately with a little seasoning.",
            koreanDescription: "모든 채소와 고기를 채썰어주세요. 각 재료를 따로 간을 조금 넣고 볶아주세요."
          },
          {
            stepName: "Arrange in a plate",
            koreanStepName: "접시에 담기",
            description: "Arrange each ingredient in separate sections of a nine-sectioned plate. Keep colors vibrant and organized.",
            koreanDescription: "접시에 각 재료를 따로 담아주세요. 색깔이 선명하고 깔끔하게 정리되도록 하세요."
          },
          {
            stepName: "Serve with crepes",
            koreanStepName: "전병과 함께 내놓기",
            description: "Serve with thin crepes and dipping sauce. Guests can wrap their own combinations.",
            koreanDescription: "얇은 전병과 찍어먹는 소스와 함께 내놓으세요. 손님들이 직접 싸서 드실 수 있습니다."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      },
      {
        name: "Japchae",
        koreanName: "잡채",
        image: "/Dishes/japchae.png",
        modalImage: "/modal-images/japchae.jpg",
        description: "Korean sweet potato starch noodles with vegetables and beef. A popular dish for celebrations and family gatherings.",
        koreanDescription: "채소와 소고기가 들어간 한국 당면 요리. 축제와 가족 모임에 인기 있는 음식입니다.",
        cookingTime: "45 mins",
        koreanCookingTime: "45분",
        categories: ["Noodles", "Main Dish", "Celebration"],
        koreanCategories: ["면류", "메인 요리", "축제"],
        timePortion: "45 mins • 6-8 servings",
        koreanTimePortion: "45분 • 6-8인분",
        ingredients: [
          "200g sweet potato noodles (dangmyeon)",
          "150g beef, thinly sliced",
          "100g spinach",
          "1 carrot, julienned",
          "1/2 onion, sliced",
          "1/2 cup mushrooms, sliced",
          "1/2 cup bell peppers, julienned",
          "2 cloves garlic, minced",
          "3 tbsp soy sauce",
          "2 tbsp sesame oil",
          "1 tbsp sugar",
          "1 tsp salt",
          "1/2 tsp black pepper",
          "1 tbsp sesame seeds",
          "Vegetable oil for cooking"
        ],
        koreanIngredients: [
          "당면 200g",
          "소고기 150g (얇게 썰어서)",
          "시금치 100g",
          "당근 1개 (채썰기)",
          "양파 1/2개 (썰어서)",
          "버섯 1/2컵 (썰어서)",
          "피망 1/2컵 (채썰기)",
          "다진 마늘 2쪽",
          "간장 3큰술",
          "참기름 2큰술",
          "설탕 1큰술",
          "소금 1작은술",
          "후추 1/2작은술",
          "깨 1큰술",
          "식용유 (조리용)"
        ],
        instructions: [
          {
            stepName: "Prepare noodles",
            koreanStepName: "당면 준비",
            description: "Soak sweet potato noodles in warm water for 30 minutes. Boil in salted water for 3 minutes, then rinse with cold water.",
            koreanDescription: "당면을 따뜻한 물에 30분간 불려주세요. 소금물에 3분간 삶은 후 찬물에 헹구세요."
          },
          {
            stepName: "Cook vegetables",
            koreanStepName: "채소 조리",
            description: "Blanch spinach and sauté carrots, onion, mushrooms, and bell peppers separately with a little oil.",
            koreanDescription: "시금치를 데치고 당근, 양파, 버섯, 피망을 기름을 조금 넣고 각각 볶아주세요."
          },
          {
            stepName: "Cook beef",
            koreanStepName: "고기 조리",
            description: "Marinate beef with 1 tbsp soy sauce and 1 tsp sugar. Stir-fry with garlic until cooked through.",
            koreanDescription: "소고기를 간장 1큰술과 설탕 1작은술로 양념하세요. 마늘과 함께 익을 때까지 볶아주세요."
          },
          {
            stepName: "Mix and season",
            koreanStepName: "섞고 양념하기",
            description: "Combine noodles, vegetables, and beef in a large bowl. Add remaining soy sauce, sesame oil, sugar, salt, and pepper. Toss well and garnish with sesame seeds.",
            koreanDescription: "큰 그릇에 당면, 채소, 고기를 넣고 섞어주세요. 남은 간장, 참기름, 설탕, 소금, 후추를 넣고 잘 섞어주세요. 깨를 뿌려 장식하세요."
          }
        ],
        recipeUrl: "https://www.jeenaskitchen.store/"
      }
    ]
  }
]; 